/**
 * 组件中的常数可以写在这个文件中
 */
// 常用组件中的 省市区 组件数据
import areaData from './area.js'
import _i18n from '@/locale/i18n' // mainjs针对引用

let areaFormat = function (obj) {
  let area = []
  if (obj) {
    let key = Object.keys(obj)
    key.map((item, index) => {
      area.push({
        code: item,
        name: obj[item]
      })
    })
  }
  return area
}
let ProvincialList = areaFormat(areaData[86]) // 省
let CityList = [] // 市
let areaList = [] // 区
ProvincialList.map((v, k) => {
  let arr = areaFormat(areaData[v.code])
  CityList = CityList.concat(arr)
})
CityList.map((v, k) => {
  let arr = areaFormat(areaData[v.code])
  areaList = areaList.concat(arr)
})
const areaInit = {
  ProvincialList: ProvincialList,
  CityList: CityList,
  areaList: areaList
}
// 基础字段 (不需要国际化，后台返回)
const component1 = [
  {
    label: '单行文本',
    icon: 'icon-danhangwenben',
    type: 'text',
    isDrag: true,
    typeText: '单行文本',
    field: {}
  },
  {
    label: '多行文本',
    icon: 'icon-duohangwenben',
    type: 'textarea',
    isDrag: true,
    typeText: '多行文本',
    field: {}
  },
  {
    label: '富文本',
    icon: 'icon-fuwenben',
    type: 'multitext',
    isDrag: true,
    typeText: '富文本',
    field: {}
  },
  {
    label: '下拉选项',
    icon: 'icon-xialaxuanxiang',
    type: 'picklist',
    isDrag: true,
    typeText: '下拉选项',
    field: {}
  },
  {
    label: '电话',
    icon: 'icon-dianhua',
    type: 'phone',
    isDrag: true,
    typeText: '电话',
    field: {}
  },
  {
    label: '电子邮箱',
    icon: 'icon-youxiang',
    type: 'email',
    isDrag: true,
    typeText: '电子邮箱',
    field: {}
  },
  {
    label: '数字',
    icon: 'icon-shuzi',
    type: 'number',
    isDrag: true,
    typeText: '数字',
    field: {}
  },
  {
    label: '日期/时间',
    icon: 'icon-riqishijian',
    type: 'datetime',
    isDrag: true,
    typeText: '日期/时间',
    field: {}
  },
  {
    label: '附件',
    icon: 'icon-fujian',
    type: 'attachment',
    isDrag: true,
    typeText: '附件',
    field: {}
  },
  {
    label: '超链接',
    icon: 'icon-chaolianjie',
    type: 'url',
    isDrag: true,
    typeText: '超链接',
    field: {}
  },
  {
    label: '定位',
    icon: 'icon-dingwei',
    type: 'location',
    isDrag: true,
    typeText: '定位',
    field: {}
  },
  {
    label: '图片',
    icon: 'icon-tupian',
    type: 'picture',
    isDrag: true,
    typeText: '图片',
    field: {}
  },
  {
    label: '复选框',
    icon: 'icon-fuxuankuang',
    type: 'multi',
    isDrag: true,
    typeText: '复选框',
    field: {}
  },
  {
    label: '人员',
    icon: 'icon-renyuan',
    type: 'personnel',
    isDrag: true,
    typeText: '人员',
    field: {}
  },
  {
    label: '部门',
    icon: 'icon-bumen',
    type: 'department',
    isDrag: true,
    typeText: '部门',
    field: {}
  },
  {
    label: '多级下拉',
    icon: 'icon-duojixiala1',
    type: 'mutlipicklist',
    isDrag: true,
    typeText: '多级下拉',
    field: {}
  },
  {
    label: '简单公式',
    icon: 'icon-jiandangongshi1',
    type: 'formula',
    isDrag: true,
    typeText: '简单公式',
    field: {}
  },
  {
    label: '省市区',
    icon: 'icon-shengshiqu',
    type: 'area',
    isDrag: true,
    typeText: '省市区',
    field: {}
  }
]
// 高级类组件 (不需要国际化，后台返回)
const component2 = [
  {
    label: '自动编号',
    icon: 'icon-zidongbianhao',
    type: 'identifier',
    isDrag: true,
    typeText: '自动编号',
    field: {}
  },
  {
    label: '流水号',
    icon: 'icon-liushuihao',
    type: 'serialnum',
    isDrag: true,
    typeText: '流水号',
    field: {}
  },
  {
    label: '关联关系',
    icon: 'icon-guanlianguanxi',
    type: 'reference',
    isDrag: true,
    typeText: '关联关系',
    field: {}
  },
  {
    label: '子表单',
    icon: 'icon-zibiaodan',
    type: 'subform',
    isDrag: true,
    typeText: '子表单',
    field: {}
  },
  {
    label: '函数公式',
    icon: 'icon-hanshugongshi',
    type: 'functionformula',
    isDrag: true,
    typeText: '函数公式',
    field: {}
  },
  {
    label: '高级公式',
    icon: 'icon-gaojigongshi',
    type: 'seniorformula',
    isDrag: true,
    typeText: '高级公式',
    field: {}
  },
  {
    label: '引用公式',
    icon: 'icon-yinyong',
    type: 'citeformula',
    isDrag: true,
    typeText: '引用公式',
    field: {}
  },
  {
    label: '条码',
    icon: 'icon-zujiantiaoma',
    type: 'barcode',
    isDrag: true,
    typeText: '条码',
    field: {}
  }
]
// 子表单组件
const subformList = function () {
  return [
    {
      name: 'subform_text_',
      label: _i18n.t('custom_backstage.text'), // '单行文本',
      type: 'text',
      typeText: _i18n.t('custom_backstage.text'), // '单行文本',
      width: '100%',
      state: '0',
      remove: '1',
      formatCheck: '0',
      formatCheckEntrys: [
        { index: '0', label: _i18n.t('base_common.nothing'), value: 'idcard' }, // 无
        { index: '1', label: _i18n.t('custom_backstage.idCardCheck'), value: 'idcard' } // 身份证号校验
      ],
      field: {
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        structure: '1',
        pointOut: _i18n.t('base_common.placeholder.input'), // '请输入',
        repeatCheck: '0',
        terminalPc: '1',
        terminalApp: '1',
        defaultValue: '',
        defaultWidth: ''
      }
    },
    {
      name: 'subform_textarea_',
      label: _i18n.t('custom_backstage.textarea'), // '多行文本',
      type: 'textarea',
      typeText: _i18n.t('custom_backstage.textarea'), // '多行文本',
      width: '100%',
      state: '0',
      remove: '1',
      field: {
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        structure: '1',
        pointOut: _i18n.t('base_common.placeholder.input'), // '请输入',
        terminalPc: '1',
        terminalApp: '1',
        defaultValue: '',
        defaultWidth: ''
      }
    },
    {
      name: 'subform_multitext_',
      label: _i18n.t('custom_backstage.multitext'), // '富文本',
      type: 'multitext',
      typeText: _i18n.t('custom_backstage.multitext'), // '富文本',
      width: '100%',
      state: '0',
      remove: '1',
      field: {
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        structure: '1',
        pointOut: '',
        terminalPc: '1',
        terminalApp: '1',
        defaultValue: '',
        defaultWidth: ''
      }
    },
    {
      name: 'subform_picklist_',
      label: _i18n.t('custom_backstage.picklist'), // '下拉选项',
      type: 'picklist',
      typeText: _i18n.t('custom_backstage.picklist'), // '下拉选项',
      width: '100%',
      state: '0',
      remove: '1',
      field: {
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        structure: '1',
        chooseType: '0',
        terminalPc: '1',
        terminalApp: '1',
        defaultEntrys: [],
        defaultWidth: ''
      },
      entrys: [
        {
          value: '0',
          label: _i18n.t('custom_backstage.option') + '1', // '选项1',
          color: '#FFFFFF'
        },
        {
          value: '1',
          label: _i18n.t('custom_backstage.option') + '2', // '选项2',
          color: '#FFFFFF'
        },
        {
          value: '2',
          label: _i18n.t('custom_backstage.option') + '3', // '选项3',
          color: '#FFFFFF'
        }
      ]
    },
    {
      name: 'subform_phone_',
      label: _i18n.t('custom_backstage.phone'), // '电话',
      type: 'phone',
      typeText: _i18n.t('custom_backstage.phone'), // '电话',
      width: '100%',
      state: '0',
      remove: '1',
      field: {
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        structure: '1',
        pointOut: _i18n.t('base_common.placeholder.input'), // '请输入',
        phoneType: '0',
        phoneLenth: '0',
        repeatCheck: '0',
        terminalPc: '1',
        terminalApp: '1',
        defaultWidth: ''
      }
    },
    {
      name: 'subform_email_',
      label: _i18n.t('custom_backstage.email'), // '电子邮箱',
      type: 'email',
      typeText: _i18n.t('custom_backstage.email'), // '电子邮箱',
      width: '100%',
      state: '0',
      remove: '1',
      field: {
        pointOut: _i18n.t('base_common.placeholder.input'), // '请输入',
        structure: '1',
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        repeatCheck: '0',
        terminalPc: '1',
        terminalApp: '1',
        defaultWidth: ''
      }
    },
    {
      name: 'subform_number_',
      label: _i18n.t('custom_backstage.number'), // '数字',
      type: 'number',
      typeText: _i18n.t('custom_backstage.number'), // '数字',
      width: '100%',
      state: '0',
      remove: '1',
      pay: '0', // 支付功能(0不开通，1为开通)
      field: {
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        structure: '1',
        pointOut: _i18n.t('base_common.placeholder.input'), // '请输入',
        numberType: '0',
        numberLenth: '2',
        betweenMin: '',
        betweenMax: '',
        terminalPc: '1',
        terminalApp: '1',
        defaultValue: '',
        numberDelimiter: '0',
        defaultWidth: '',
        unit: ''
      }
    },
    {
      name: 'subform_datetime_',
      label: _i18n.t('custom_backstage.datetime'), // '日期/时间',
      type: 'datetime',
      typeText: _i18n.t('custom_backstage.datetime'), // '日期/时间',
      width: '100%',
      state: '0',
      remove: '1',
      field: {
        formatType: 'yyyy-MM-dd',
        defaultValueId: '0',
        defaultValue: '',
        structure: '1',
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        terminalPc: '1',
        terminalApp: '1',
        defaultWidth: ''
      }
    },
    {
      name: 'subform_attachment_',
      label: _i18n.t('custom_backstage.attachment'), // '附件',
      type: 'attachment',
      typeText: _i18n.t('custom_backstage.attachment'), // '附件',
      width: '100%',
      state: '0',
      remove: '1',
      field: {
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        structure: '1',
        countLimit: '0',
        maxCount: '10',
        maxSize: '100',
        terminalPc: '1',
        terminalApp: '1',
        defaultWidth: ''
      },
      entrys: []
    },
    {
      name: 'subform_url_',
      label: _i18n.t('custom_backstage.url'), // '超链接',
      type: 'url',
      typeText: _i18n.t('custom_backstage.url'), // '超链接',
      width: '100%',
      state: '0',
      remove: '1',
      field: {
        pointOut: _i18n.t('base_common.placeholder.input'), // '请输入',
        defaultValue: '',
        structure: '1',
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        terminalPc: '1',
        terminalApp: '1',
        defaultWidth: ''
      }
    },
    {
      name: 'subform_location_',
      label: _i18n.t('custom_backstage.location'), // '定位',
      type: 'location',
      typeText: _i18n.t('custom_backstage.location'), // '定位',
      width: '100%',
      state: '0',
      remove: '1',
      field: {
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        structure: '1',
        pointOut: _i18n.t('base_common.placeholder.input'), // '请输入',
        terminalPc: '1',
        terminalApp: '1',
        defaultValue: '1',
        defaultWidth: '',
        positionRangeSet: '0',
        positionRangeValue: 200
      }
    },
    {
      name: 'subform_picture_',
      label: _i18n.t('custom_backstage.picture'), // '图片',
      type: 'picture',
      typeText: _i18n.t('custom_backstage.picture'), // '图片',
      width: '100%',
      state: '0',
      remove: '1',
      field: {
        structure: '1',
        imageSize: '60px*60px',
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        terminalPc: '1',
        terminalApp: '1',
        countLimit: '0',
        maxCount: '10',
        maxSize: '10',
        defaultWidth: '',
        photoUploadOnly: false
      },
      entrys: []
    },
    {
      name: 'subform_multi_',
      label: _i18n.t('custom_backstage.multi'), // '复选框',
      type: 'multi',
      typeText: _i18n.t('custom_backstage.multi'), // '复选框',
      width: '100%',
      state: '0',
      remove: '1',
      field: {
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        structure: '1',
        chooseType: '0',
        terminalPc: '1',
        terminalApp: '1',
        defaultEntrys: [],
        defaultWidth: ''
      },
      entrys: [
        {
          value: '0',
          label: _i18n.t('custom_backstage.option') + '1' // '选项1'
        },
        {
          value: '1',
          label: _i18n.t('custom_backstage.option') + '2' // '选项2'
        }
      ]
    },
    {
      name: 'subform_mutlipicklist_',
      label: _i18n.t('custom_backstage.mutlipicklist'), // '多级下拉',
      type: 'mutlipicklist',
      typeText: _i18n.t('custom_backstage.mutlipicklist'), // '多级下拉',
      width: '100%',
      state: '0',
      remove: '1',
      field: {
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        structure: '1',
        selectType: '0',
        terminalPc: '1',
        terminalApp: '1',
        defaultWidth: ''
      },
      defaultEntrys: {
        oneDefaultValue: '', // 一级下拉选项默认值
        oneDefaultValueId: '', // 一级下拉选项默认值ID
        oneDefaultValueColor: '', // 一级下拉选项默认值颜色
        twoDefaultValue: '', // 二级下拉选默认值
        twoDefaultValueId: '', // 二级下拉选默认值ID
        twoDefaultValueColor: '', // 二级下拉选默认值颜色
        threeDefaultValue: '', // 三级下拉选项默认值
        threeDefaultValueId: '', // 三级下拉选项默认值ID
        threeDefaultValueColor: '' // 三级下拉选项默认值颜色
      },
      entrys: [
        {
          value: '0', // 一级下拉选项key
          label: _i18n.t('custom_backstage.oneOption') + '1', // '一级选项1', // 一级下拉选项val
          color: '#FFFFFF', // 一级下拉选项颜色
          subList: []
        },
        {
          value: '1', // 一级下拉选项key
          label: _i18n.t('custom_backstage.oneOption') + '2', // '一级选项2', // 一级下拉选项val
          color: '#FFFFFF', // 一级下拉选项颜色
          subList: []
        }
      ]
    },
    {
      name: 'subform_personnel_',
      label: _i18n.t('custom_backstage.personnel'), // '人员',
      type: 'personnel',
      typeText: _i18n.t('custom_backstage.personnel'), // '人员',
      width: '100%',
      state: '0',
      remove: '0',
      field: {
        chooseType: '0',
        defaultPersonnel: [],
        chooseRange: [],
        structure: '1',
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        terminalPc: '1',
        terminalApp: '1',
        defaultWidth: ''
      }
    },
    {
      name: 'subform_department_',
      label: _i18n.t('custom_backstage.department'), // '部门',
      type: 'department',
      typeText: _i18n.t('custom_backstage.department'), // '部门',
      width: '100%',
      state: '0',
      remove: '0',
      field: {
        chooseType: '0',
        defaultDepartment: [],
        chooseRange: [],
        structure: '1',
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        terminalPc: '1',
        terminalApp: '1',
        defaultWidth: ''
      }
    },
    {
      name: 'subform_area_',
      label: _i18n.t('custom_backstage.area'), // '省市区',
      type: 'area',
      typeText: _i18n.t('custom_backstage.area'), // '省市区',
      width: '100%',
      state: '0',
      remove: '0',
      field: {
        structure: '1',
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        terminalPc: '1',
        terminalApp: '1',
        chooseType: '0',
        areaType: '0',
        defaultValue: '',
        defaultWidth: ''
      }
    },
    // {
    //   'name': 'subform_identifier_',
    //   'label': '自动编号',
    //   'type': 'identifier',
    //   'typeText': '自动编号',
    //   'width': '100%',
    //   'state': '0',
    //   'remove': '0',
    //   'field': {
    //     'structure': '1',
    //     'fieldControl': '0',
    //     'addView': '0',
    //     'editView': '0',
    //     'terminalPc': '1',
    //     'terminalApp': '1',
    //     'defaultValue': ''
    //   },
    //   'numbering': {
    //     'dateValue': '',
    //     'fixedValue': '',
    //     'serialValue': ''
    //   }
    // },
    {
      name: 'subform_reference_',
      label: _i18n.t('custom_backstage.reference'), // '关联关系',
      type: 'reference',
      typeText: _i18n.t('custom_backstage.reference'), // '关联关系',
      width: '100%',
      state: '0',
      remove: '1',
      field: {
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        pointOut: _i18n.t('base_common.placeholder.select'), // '请选择',
        repeatCheck: '0',
        structure: '1',
        terminalPc: '1',
        terminalApp: '1',
        allowScan: '0',
        defaultWidth: ''
      },
      relevanceModule: {
        moduleLabel: '',
        moduleName: ''
      },
      relevanceField: {
        fieldLabel: '',
        fieldName: ''
      },
      searchFields: [],
      relevanceWhere: [],
      seniorWhere: ''
    },
    {
      name: 'subform_objective_',
      label: '关联目标',
      type: 'objective',
      typeText: '关联目标',
      width: '100%',
      state: '0',
      remove: '1',
      relevanceModule: {
        moduleLabel: '目标管理',
        moduleName: 'objective'
      },
      relevanceField: {
        fieldLabel: '目标名称',
        fieldName: 'title'
      },
      field: {
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        pointOut: '',
        repeatCheck: '0',
        structure: '1',
        terminalPc: '1',
        terminalApp: '1',
        allowScan: '0',
        defaultWidth: ''
      }
    },
    {
      name: 'subform_formula_',
      label: _i18n.t('custom_backstage.formula'), // '简单公式',
      type: 'formula',
      typeText: _i18n.t('custom_backstage.formula'), // '简单公式',
      width: '100%',
      state: '0',
      remove: '1',
      field: {
        structure: '1',
        fieldControl: '1',
        addView: '1',
        editView: '1',
        detailView: '1',
        formulaEn: '',
        formulaCh: '',
        numberType: '0',
        decimalLen: '2',
        accuracy: '0',
        formulaCalculates: '0',
        terminalPc: '1',
        terminalApp: '1',
        numberDelimiter: '0',
        defaultWidth: ''
      }
    },
    {
      name: 'subform_functionformula_',
      label: _i18n.t('custom_backstage.functionformula'), // '函数公式',
      type: 'functionformula',
      typeText: _i18n.t('custom_backstage.functionformula'), // '函数公式',
      width: '100%',
      state: '0',
      remove: '1',
      field: {
        structure: '1',
        fieldControl: '1',
        addView: '1',
        editView: '1',
        detailView: '1',
        formulaEn: '',
        formulaCh: '',
        numberType: '3',
        decimalLen: '2',
        accuracy: '0',
        formulaCalculates: '0',
        terminalPc: '1',
        terminalApp: '1',
        chooseType: 'yyyy-MM-dd',
        numberDelimiter: '0',
        defaultWidth: ''
      }
    },
    {
      name: 'subform_citeformula_',
      label: _i18n.t('custom_backstage.citeformula'), // '引用公式',
      type: 'citeformula',
      typeText: _i18n.t('custom_backstage.citeformula'), // '引用公式',
      width: '100%',
      state: '0',
      remove: '1',
      field: {
        structure: '1',
        fieldControl: '1',
        addView: '1',
        editView: '1',
        detailView: '1',
        formulaEn: '',
        formulaCh: '',
        numberType: '3',
        decimalLen: '2',
        accuracy: '0',
        formulaCalculates: '0',
        terminalPc: '1',
        terminalApp: '1',
        chooseType: 'yyyy-MM-dd',
        referenceFields: '',
        resultList: [],
        numberDelimiter: '0',
        defaultWidth: ''
      }
    },
    {
      name: 'subform_connectdepartments_',
      label: '跨机构部门',
      type: 'connectdepartments',
      typeText: '跨机构部门',
      width: '100%',
      state: '0',
      remove: '0',
      field: {
        chooseType: '0',
        defaultPersonnel: [],
        defaultEntrys: [],
        chooseRange: [],
        structure: '1',
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        terminalPc: '1',
        terminalApp: '1',
        defaultWidth: ''
      }
    },
    {
      name: 'subform_connectpersonnel_',
      label: '跨机构人员',
      type: 'connectpersonnel',
      typeText: '跨机构人员',
      width: '100%',
      state: '0',
      remove: '0',
      field: {
        chooseType: '0',
        defaultPersonnel: [],
        defaultEntrys: [],
        chooseRange: [],
        structure: '1',
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        terminalPc: '1',
        terminalApp: '1',
        defaultWidth: ''
      }
    },
    {
      name: 'subform_connectrole_',
      label: '跨机构角色',
      type: 'connectrole',
      typeText: '跨机构角色',
      width: '100%',
      state: '0',
      remove: '0',
      field: {
        chooseType: '0',
        defaultPersonnel: [],
        defaultEntrys: [],
        chooseRange: [],
        structure: '1',
        fieldControl: '0',
        addView: '1',
        editView: '1',
        detailView: '1',
        terminalPc: '1',
        terminalApp: '1',
        defaultWidth: ''
      }
    }
  ]
}
// 公式符号
const symbolList = function () {
  return [
    { code: '+', name: _i18n.t('utils.plus') + ' +' }, // 加
    { code: '-', name: _i18n.t('utils.reduce') + ' -' }, // 减
    { code: '*', name: _i18n.t('utils.ride') + ' *' }, // 乘
    { code: '/', name: _i18n.t('utils.except') + ' /' }, // 除
    { code: '^', name: _i18n.t('utils.Involution') + ' ^' }, // 乘方
    { code: '(', name: _i18n.t('utils.leftBrackets') + ' (' }, // 左括号
    { code: ')', name: _i18n.t('utils.lrightBrackets') + ' )' }, // 右括号
    { code: '&', name: _i18n.t('utils.chuanLian') + ' &' }, // 串联
    { code: '==', name: _i18n.t('utils.dengyu') + ' ==' }, // 等于
    { code: '<>', name: _i18n.t('utils.budengyu') + ' <>' }, // 不等于
    { code: '>', name: _i18n.t('utils.dayu') + ' >' }, // 大于
    { code: '<', name: _i18n.t('utils.xiaoyu') + ' <' }, // 小于
    { code: '>=', name: _i18n.t('utils.dayudengyu') + ' >=' }, // 大于或等于
    { code: '<=', name: _i18n.t('utils.xiaoyugengyu') + ' <=' } // 小于或等于
  ]
}
// 公式类型描述1
const formulaType = function () {
  return [
    {
      name: _i18n.t('utils.logic'), // '逻辑',
      list: [
        // {
        //   code: 'CASE WHEN THEN ELSE END',
        //   name: 'CASE',
        //   title: 'CASE',
        //   describe: '根据一系列值检查一个给定表达式。如果表达式等于其中一个值，则返回相应结果。如果它不等于任何值，则返回ELSE结果。',
        //   example: '示例：客户信用等级= CASEWHEN 订单总金额>100000 THEN "A级"WHEN 订单总金额<100000 AND 订单总金额  >10000  THEN "B级"ELSE "C级"END'
        // },
        {
          code: 'IF THEN \nELSE IF THEN \nEND',
          name: 'IF',
          title: 'IF THEN',
          describe: _i18n.t('utils.formulaInfo10'), // '如果条件满足(布尔表达式返回 TRUE 时)，则在 IF 关键字及其条件之后执行 语句。可选的 ELSE 关键字引入备用的 语句，当不满足 IF 条件时，就执行这个(ELSE)语句。',
          // example: '示例：IF 分数==100 THEN \'AA\' ELSE IF 分数>=90 THEN \'A\' ELSE IF 分数>=80 THEN \'B\' ELSE IF 分数>=70 THEN \'C\' ELSE IF 分数>=60 THEN \'D\' ELSE \'F\' END'
          example: _i18n.t('utils.example') + '：' + _i18n.t('utils.formulaInfo11')
        },
        {
          code: 'ISNULL()',
          name: 'ISNULL',
          title: 'ISNULL()',
          describe: _i18n.t('utils.formulaInfo12'), // '确定表达式是否为空(空白)，如果是则返回 TRUE(真)。如果它包含一个值，则该函数返回 FALSE(假)。',
          // example: '示例：ISNULL(订单.总金额,0)若订单.总金额不为NULL则显示订单.总金额，若为NULL则显示逗号后面的0'
          example: _i18n.t('utils.example') + '：' + _i18n.t('utils.formulaInfo13')
        },
        {
          code: 'AND()',
          name: 'AND',
          title: 'AND(logical1,logical2,logical3...)',
          describe: _i18n.t('utils.formulaInfo14'), // '检查是否所有参数均为真，如果所有参数均为真则返回TRUE。',
          example: _i18n.t('utils.example') + '：AND(2>1,3>2)=TRUE'
        },
        {
          code: 'ISBLANK()',
          name: 'ISBLANK',
          title: 'ISBLANK(expression)',
          describe: _i18n.t('utils.formulaInfo15'), // '检查表达式是否具有值，如果没有值则发返回TRUE。',
          example: _i18n.t('utils.example') + '：ISBLANK(1000)=FALSE'
        },
        {
          code: 'NOT()',
          name: 'NOT',
          title: 'NOT(logical)',
          describe: _i18n.t('utils.formulaInfo16'), // '反函数，用户来确保一个值不等于某一个特定的值。',
          // example: '示例：IF NOT(年龄>=18) THEN \'未成年，不能进入游戏\' END'
          example: _i18n.t('utils.example') + '：' + _i18n.t('utils.formulaInfo17')
        },
        {
          code: 'ISNUMBER()',
          name: 'ISNUMBER',
          title: 'ISNUMBER(value)',
          describe: _i18n.t('utils.formulaInfo18'), // '文本值为数字时，返回TRUE，反之FALSE。',
          example: _i18n.t('utils.example') + '：ISNUMBER(3)=TRUE'
        },
        {
          code: 'OR()',
          name: 'OR',
          title: 'OR(logical1,logical2,logical3...)',
          describe: _i18n.t('utils.formulaInfo19'), // '检查任一参数是否为真，如果有一个参数为真则返回TRUE。',
          example: _i18n.t('utils.example') + '：OR(2>1,2>3)=TRUE'
        },
        {
          code: 'CONTAINS()',
          name: 'CONTAINS',
          title: 'CONTAINS(text,compare_text)',
          describe: _i18n.t('utils.formulaInfo20'), // '检查text是否包含compare_text，如果是则返回TRUE。',
          // example: '示例：CONTAINS(客户地址,\'深圳市\')=TRUE'
          example: _i18n.t('utils.example') + '：' + _i18n.t('utils.formulaInfo21')
        },
        {
          code: 'REGEX()',
          name: 'REGEX',
          title: 'REGEX(text,regex_text)',
          describe: _i18n.t('utils.formulaInfo22'), // '如果文本与正则表达式regex_text相匹配，则返回TRUE。',
          // example: '示例：REGEX(手机,\'^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$)\')'
          example: _i18n.t('utils.example') + '：' + _i18n.t('utils.formulaInfo23')
        },
        {
          code: 'RANDOM(7,1)',
          name: 'RANDOM',
          title: 'RANDOM(7,1)',
          describe:
            '7代表随机生成7位数，只能输入4-20的正整数；随机码复杂程度：1代表大写字母+数字，2代表小写字母+数字，3代表大小写字母+数字',
          // example: '示例：REGEX(手机,\'^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$)\')'
          example: _i18n.t('utils.example') + 'RANDOM(7,3)=F8DDxa3'
        }
      ]
    },
    {
      name: _i18n.t('utils.dataAndTime'), // '日期和时间',
      list: [
        {
          code: 'YEAR()',
          name: 'YEAR',
          title: 'YEAR(date)',
          describe: _i18n.t('utils.formulaInfo1'), // '返回指定日期字段中年份的正数。',
          // example: '示例：YEAR(2017-12-28)=2017'
          example: _i18n.t('utils.example') + '：YEAR(2017-12-28)=2017'
        },
        {
          code: 'MONTH()',
          name: 'MONTH',
          title: 'MONTH(date)',
          describe: _i18n.t('utils.formulaInfo2'), // '返回指定日期字段中月份的正数。',
          example: '示例：MONTH(2017-12-28)=12'
        },
        {
          code: 'DAY()',
          name: 'DAY',
          title: 'DAY(date)',
          describe: _i18n.t('utils.formulaInfo24'), // '返回指定日期字段中某月的天数。',
          // example: '示例：DAY(2017-12-28)=28'
          example: _i18n.t('utils.example') + '：DAY(2017-12-28)=28'
        },
        {
          code: 'NOW()',
          name: 'NOW',
          title: 'NOW(date)',
          describe: _i18n.t('utils.formulaInfo3'), // '返回表示当前时刻的日期时间。',
          // example: '示例：NOW()  =  2017-12-28 12:00:00'
          example: _i18n.t('utils.example') + '：NOW()  =  2017-12-28 12:00:00'
        },
        {
          code: 'TODAY()',
          name: 'TODAY',
          title: 'TODAY(date)',
          describe: _i18n.t('utils.formulaInfo4'), // '返回表示当前时刻的日期。',
          example: _i18n.t('utils.example') + '：TODAY()  =  2017-12-28'
        },
        {
          code: 'DATEDIFF()',
          name: 'DATEDIFF',
          title: 'DATEDIFF(datepart,startdate,enddate)',
          describe: _i18n.t('utils.formulaInfo5'), // '返回两个日期之间的天数。 Y:年、M:月、D:日、H:时、N:分、S:秒；',
          example: _i18n.t('utils.example') + "：DATEDIFF('" + 'D' + "',2017-12-25,2017-12-28)=3"
        },
        {
          code: 'DATEADD()',
          name: 'DATEADD',
          title: 'DATEADD(datepart,number,date)',
          describe: _i18n.t('utils.formulaInfo6'), // '在向指定日期加上一段时间的基础上，返回新的 datetime 值。Y:年、M:月、D:日、H:时、N:分、S:秒；',
          example: _i18n.t('utils.example') + "：DATEADD('" + 'D' + "',1,2017-12-28)=2017-12-29"
        },
        {
          code: 'EXTRACT()',
          name: 'EXTRACT',
          title: "EXTRACT('D','current_date',2017-12-25)",
          describe: _i18n.t('utils.formulaInfo7'), // '返回两个日期之间的时间。Y:年、M:月、D:日',
          // example: '示例：未联系天数=EXTRACT(\'D\',\'current_date\',2017-12-25)，实时计算结果值。'
          example: _i18n.t('utils.example') + '：' + _i18n.t('utils.formulaInfo42')
        },
        {
          code: 'DATE()',
          name: 'DATE',
          title: 'DATE(2017,12,28)',
          describe: _i18n.t('utils.formulaInfo8'), // '通过年、月、日创建日期。',
          example: _i18n.t('utils.example') + '：DATE(2017,12,28)=2017-12-28'
        },
        {
          code: 'HOUR()',
          name: 'HOUR',
          title: 'HOUR(2017-12-28 12:07)',
          describe: _i18n.t('utils.formulaInfo47'), // '在日期时间字段中返回小时数',
          example: _i18n.t('utils.example') + '：HOUR(2017-12-28 12:07)=12'
        },
        {
          code: 'MINUTE()',
          name: 'MINUTE',
          title: 'MINUTE(2017-12-28 12:07)',
          describe: _i18n.t('utils.formulaInfo48'), // '在日期时间字段中返回分钟数',
          example: _i18n.t('utils.example') + '：MINUTE(2017-12-28 12:07)=07'
        },
        {
          code: 'WEEKDAY()',
          name: 'WEEKDAY',
          title: 'WEEKDAY(2017-12-28 12:07)',
          describe: '返回指定日期字段中所对应的星期数', // '返回指定日期字段中所对应的星期数',
          example: _i18n.t('utils.example') + '：WEEKDAY（2021-06-01 12:00:00）=星期二'
        }
      ]
    },
    {
      name: _i18n.t('utils.text'), // '文本',
      list: [
        {
          code: 'LEFT()',
          name: 'LEFT',
          title: 'LEFT(text,num_chars)',
          describe: _i18n.t('utils.formulaInfo25'), // '返回从文本字符串开头算起的指定数量的字符。',
          example: _i18n.t('utils.example') + '：LEFT(132467,3)=132'
        },
        {
          code: 'LENGTH()',
          name: 'LENGTH',
          title: 'LENGTH(text)',
          describe: _i18n.t('utils.formulaInfo26'), // '返回指定的文本字符串中所含的字符数。',
          example: _i18n.t('utils.example') + '：LEN(13 12)=5'
        },
        {
          code: 'RIGHT()',
          name: 'RIGHT',
          title: 'RIGHT(text,num_chars)',
          describe: _i18n.t('utils.formulaInfo27'), // '返回从文本字符串右边算起的指定数量的字符。',
          example: _i18n.t('utils.example') + '：RIGHT(13255467,3)=467'
        },
        {
          code: 'TEXT()',
          name: 'TEXT',
          title: 'TEXT()',
          describe: _i18n.t('utils.formulaInfo28'), // '将一个值转换为使用标准显示格式的文本。',
          example: ''
        },
        {
          code: 'VALUE()',
          name: 'VALUE',
          title: 'VALUE()',
          describe: _i18n.t('utils.formulaInfo29'), // '将文本字符串转换为数字类型。',
          example: ''
        },
        {
          code: 'MID()',
          name: 'MID',
          title: 'MID(text,start_num,num_chars)',
          describe: _i18n.t('utils.formulaInfo30'), // '给定字符串的起始位置和长度，返回字符串中间的字符。',
          example: _i18n.t('utils.example') + '：MID(201872455,4,3)=872'
        },
        {
          code: 'BEGINS()',
          name: 'BEGINS',
          title: 'BEGINS(text,compare_text)',
          describe: _i18n.t('utils.formulaInfo31'), // '检查文本是否以特定字符开头，如果是则返回TRUE，否则返回FALSE。',
          // example: '示例：BEGINS(会员卡号,\'801\')'
          example: _i18n.t('utils.example') + '：' + _i18n.t('utils.formulaInfo43')
        }
      ]
    },
    {
      name: _i18n.t('utils.number'), // '数字',
      list: [
        {
          code: 'ABS()',
          name: 'ABS',
          title: 'ABS(number)',
          describe: _i18n.t('utils.formulaInfo9'), // '返回数值的绝对值(不含正负号的数字)。',
          example: _i18n.t('utils.example') + '：ABS(10-25)=15'
        },
        {
          code: 'NUMBERSTRING()',
          name: 'NUMBERSTRING',
          title: 'NUMBERSTRING(number)',
          describe: _i18n.t('utils.formulaInfo46'), // '将小写数字转换成中文大写。',
          example: _i18n.t('utils.example') + 'NUMBERSTRING(1234)=壹仟贰佰叁拾肆'
        }
      ]
    }
  ]
}
// 公式类型描述2
const formulaType2 = function () {
  return [
    {
      name: _i18n.t('utils.summary'), // '汇总',
      list: [
        {
          code: `COUNT()`,
          name: 'COUNT',
          title: 'COUNT ()',
          describe: _i18n.t('utils.formulaInfo32'), // '返回组中的各项项数。',
          // example: '示例：COUNT(产品.产品编号) 返回组中的项数'
          example: _i18n.t('utils.example') + '：' + _i18n.t('utils.formulaInfo33')
        },
        {
          code: `COUNT(CASE WHEN THEN \nELSE NULL \nEND)`,
          name: 'COUNT CASE',
          title: 'COUNT CASE()',
          describe: _i18n.t('utils.formulaInfo32'), // '返回组中的各项项数。',
          // example: '水果分类销售次数=COUNT(CASE WHEN {产品类型}==\'水果\' THEN {产品编号} ELSE null END)，代表求水果分类的销售次数，不是蔬果分类的返回为0'
          example: _i18n.t('utils.example') + '：' + _i18n.t('utils.formulaInfo51')
        },
        {
          code: `COUNT IF()`,
          name: 'COUNT IF',
          title: 'COUNT IF()',
          describe: '返回组中的各项项数，如果名称相同则去重后计算，即相同的名称仅计算为1次。',
          example:
            '示例：COUNT IF（{观众进展记录.手机号}），相同手机号码仅计算一次，不同手机号码累加'
        },
        {
          code: 'SUM()',
          name: 'SUM',
          title: 'SUM()',
          describe: _i18n.t('utils.formulaInfo34'), // '返回组中各项的和。',
          // example: '示例：客户成交总金额=SUM(合同.总金额)'
          example: _i18n.t('utils.example') + '：' + _i18n.t('utils.formulaInfo35')
        },
        {
          code: `SUM(CASE WHEN THEN \nELSE 0 \nEND)`,
          name: 'SUM CASE',
          title: 'SUM CASE()',
          describe: _i18n.t('utils.formulaInfo34'), // '返回组中各项的和',
          // example: '客户成交总金额=SUM(CASE WHEN {合同状态}==\'已签约\' THEN {合同.总金额} ELSE 0 END)'
          example: _i18n.t('utils.example') + '：' + _i18n.t('utils.formulaInfo52')
        },
        {
          code: 'MIN()',
          name: 'MIN',
          title: 'MIN()',
          describe: _i18n.t('utils.formulaInfo36'), // '返回一系列数字中的最小数字。',
          // example: '示例：学员最低成绩=MIN(成绩.分数)'
          example: _i18n.t('utils.example') + '：' + _i18n.t('utils.formulaInfo37')
        },
        {
          code: 'MAX()',
          name: 'MAX',
          title: 'MAX()',
          describe: _i18n.t('utils.formulaInfo38'), // '返回一系列数字中的最大数字。',
          // example: '示例：学员最低成绩=MAN(成绩.分数)  '
          example: _i18n.t('utils.example') + '：' + _i18n.t('utils.formulaInfo39')
        },
        {
          code: 'AVG()',
          name: 'AVG',
          title: 'AVG()',
          describe: _i18n.t('utils.formulaInfo40'), // '返回组中的平均值。',
          // example: '示例：会员平均消费=AVG(销售订单.金额)'
          example: _i18n.t('utils.example') + '：' + _i18n.t('utils.formulaInfo41')
        },
        {
          code: `AVG(CASE WHEN THEN \nELSE 0 \nEND)`,
          name: 'AVG CASE',
          title: 'AVG CASE()',
          describe: _i18n.t('utils.formulaInfo40'), // '返回组中的平均值。',
          // example: '会员平均消费=AVG（CASE WHEN {会员状态}==\'会员\' THEN {销售订单.金额} ELSE 0 END）'
          example: _i18n.t('utils.example') + '：' + _i18n.t('utils.formulaInfo53')
        }
      ]
    }
  ]
}
// 公式返回类型-简单
const formulaReturn1 = function () {
  return [
    { value: '0', label: _i18n.t('data_analysis.number') }, // 数字
    { value: '1', label: _i18n.t('data_analysis.integer') }, // 整数
    { value: '2', label: _i18n.t('data_analysis.percent') } // 百分比
  ]
}
// 公式返回类型-复杂
const formulaReturn2 = function () {
  return [
    { value: '0', label: _i18n.t('data_analysis.number') }, // 数字
    { value: '1', label: _i18n.t('data_analysis.integer') }, // 整数
    { value: '2', label: _i18n.t('data_analysis.percent') }, // 百分比
    { value: '3', label: _i18n.t('utils.text') }, // 文本
    { value: '4', label: _i18n.t('custom_backstage.datetime') } // 日期时间
  ]
}
// 24种颜色值
const colors24 = [
  '#2780F7',
  '#FB8130',
  '#15A9ED',
  '#1FA567',
  '#FC9C09',
  '#15A28C',
  '#4AB0AF',
  '#E93E33',
  '#28B7EE',
  '#815CF7',
  '#5E5FF5',
  '#FC6139'
]
// 24种颜色值
const colorsPicklist24 = [
  '#CD5D82',
  '#D97978',
  '#F88F41',
  '#FABC01',
  '#F9B239',
  '#99D85B',
  '#66C060',
  '#4CAC68',
  '#19BFA4',
  '#2EBCFF',
  '#2CCCDA',
  '#70D6D7',
  '#B9C9D6',
  '#34A7B6',
  '#0062B1',
  '#2A8DB7',
  '#7076FA',
  '#8186EC',
  '#8E75CB',
  '#C472EE',
  '#BC74CB',
  '#EF7EDE',
  '#F969AA',
  '#FA5A55',
  '#FF7748'
]
// 应用默认图标
const defaultAppIcon = [
  'icon-apps-library-1',
  'icon-apps-library-2',
  'icon-apps-library-3',
  'icon-apps-library-4',
  'icon-apps-library-5',
  'icon-apps-library-6',
  'icon-apps-library-7',
  'icon-apps-library-8',
  'icon-apps-library-9',
  'icon-apps-library-10',
  'icon-apps-library-11',
  'icon-apps-library-12',
  'icon-apps-library-13',
  'icon-apps-library-14',
  'icon-apps-library-15',
  'icon-apps-library-16',
  'icon-apps-library-17',
  'icon-apps-library-18',
  'icon-apps-library-19',
  'icon-apps-library-20',
  'icon-apps-library-21',
  'icon-apps-library-22',
  'icon-apps-library-23',
  'icon-apps-library-24',
  'icon-apps-library-25',
  'icon-apps-library-26',
  'icon-apps-library-27',
  'icon-apps-library-28',
  'icon-apps-library-29',
  'icon-apps-library-30',
  'icon-apps-library-31',
  'icon-apps-library-32',
  'icon-apps-library-33',
  'icon-apps-library-34',
  'icon-apps-library-35',
  'icon-apps-library-36',
  'icon-apps-library-37',
  'icon-apps-library-38',
  'icon-apps-library-39',
  'icon-apps-library-40',
  'icon-apps-library-41',
  'icon-apps-library-42',
  'icon-apps-library-43',
  'icon-apps-library-44',
  'icon-apps-library-45',
  'icon-apps-library-46',
  'icon-apps-library-47',
  'icon-apps-library-48',
  'icon-apps-library-49',
  'icon-apps-library-50',
  'icon-apps-library-51',
  'icon-apps-library-52',
  'icon-apps-library-53',
  'icon-apps-library-54',
  'icon-apps-library-55',
  'icon-apps-library-56',
  'icon-apps-library-57',
  'icon-apps-library-58',
  'icon-apps-library-59',
  'icon-apps-library-60',
  'icon-apps-library-61',
  'icon-apps-library-62',
  'icon-apps-library-63',
  'icon-apps-library-64',
  'icon-apps-library-65'
]
// 模块默认图标
const defaultModuleIcon = [
  'icon-modules-library-1',
  'icon-modules-library-2',
  'icon-modules-library-3',
  'icon-modules-library-4',
  'icon-modules-library-5',
  'icon-modules-library-6',
  'icon-modules-library-7',
  'icon-modules-library-8',
  'icon-modules-library-9',
  'icon-modules-library-10',
  'icon-modules-library-11',
  'icon-modules-library-12',
  'icon-modules-library-13',
  'icon-modules-library-14',
  'icon-modules-library-15',
  'icon-modules-library-16',
  'icon-modules-library-17',
  'icon-modules-library-18',
  'icon-modules-library-19',
  'icon-modules-library-20',
  'icon-modules-library-21',
  'icon-modules-library-22',
  'icon-modules-library-23',
  'icon-modules-library-24',
  'icon-modules-library-25',
  'icon-modules-library-26',
  'icon-modules-library-27',
  'icon-modules-library-28',
  'icon-modules-library-29',
  'icon-modules-library-30',
  'icon-modules-library-31',
  'icon-modules-library-32',
  'icon-modules-library-33',
  'icon-modules-library-34',
  'icon-modules-library-35',
  'icon-modules-library-36',
  'icon-modules-library-37',
  'icon-modules-library-38',
  'icon-modules-library-39',
  'icon-modules-library-40',
  'icon-modules-library-41',
  'icon-modules-library-42',
  'icon-modules-library-43',
  'icon-modules-library-44',
  'icon-modules-library-45',
  'icon-modules-library-46',
  'icon-modules-library-47',
  'icon-modules-library-48',
  'icon-modules-library-49',
  'icon-modules-library-50',
  'icon-modules-library-51',
  'icon-modules-library-52',
  'icon-modules-library-53',
  'icon-modules-library-54',
  'icon-modules-library-55',
  'icon-modules-library-56',
  'icon-modules-library-57',
  'icon-modules-library-58',
  'icon-modules-library-59',
  'icon-modules-library-60',
  'icon-modules-library-61',
  'icon-modules-library-62',
  'icon-modules-library-63',
  'icon-modules-library-64',
  'icon-modules-library-65',
  'icon-modules-library-66',
  'icon-modules-library-67'
]
// 创建默认模块
const defaultModule = function () {
  return {
    bean: '',
    title: '',
    version: '0',
    icon_type: '0',
    icon_url: '',
    icon_color: '',
    applicationId: '',
    applicationName: '',
    pageNum: 0,
    pageName: _i18n.t('custom_backstage.biaozhunPage'), // '标准页面',
    commentControl: '1',
    dynamicControl: '1',
    terminalPc: '1',
    terminalApp: '1',
    appearance: {
      themeId: 0,
      pageWidth: 900,
      pageBgType: 0,
      pageBgImg: '',
      pageBgColor: '#CFE7FA',
      headerBgType: 0,
      headerBgImg: '',
      headerBgColor: '#1989FA',
      headerBgOpacity: _i18n.t('custom_backstage.noOpacity'), // '不透明',
      headerModuleName: '',
      headerTextColor: '#FFFFFF',
      headerTextSize: 72,
      headerModuleDescribe: '',
      describeTextColor: '#FFFFFF',
      describeTextSize: 18,
      contentBgcolor: '#FFFFFF',
      contentBgOpacity: _i18n.t('custom_backstage.noOpacity'), // '不透明',
      commitBgType: 0,
      commitBgImg: '',
      commitBgColor: '#FFFFFF',
      commitBgOpacity: _i18n.t('custom_backstage.noOpacity'), // '不透明',
      commitButtonColor: '#4A90E2',
      commitButtonShow: 1,
      commitButtonTextFirst: _i18n.t('base_common.cancel'), // '取消',
      commitButtonTextSecond: _i18n.t('base_common.save'), // '保存',
      commitButtonWidth: 0,
      commitButtonPosition: 2
    }
  }
}
// 主题外观
const themes = function () {
  return [
    {
      id: -1,
      text: _i18n.t('utils.noPicture'),
      color: '#E1FCF9',
      url: 'theme-s--1.png',
      background: 'theme-l--1.png'
    }, // 无图
    {
      id: 0,
      text: _i18n.t('utils.xiuxian'),
      color: '#CFE7FA',
      url: 'theme-s-0.png',
      background: 'theme-l-0.png'
    }, // 休闲
    {
      id: 1,
      text: _i18n.t('utils.relax'),
      color: '#E1FCF9 ',
      url: 'theme-s-1.png',
      background: 'theme-l-1.png'
    }, // 轻松
    {
      id: 2,
      text: _i18n.t('utils.business'),
      color: '#D1D6EB',
      url: 'theme-s-2.png',
      background: 'theme-l-2.png'
    }, // 商务
    {
      id: 3,
      text: _i18n.t('utils.hezuo'),
      color: '#F4EEDB',
      url: 'theme-s-3.png',
      background: 'theme-l-3.png'
    }, // 合作
    {
      id: 4,
      text: _i18n.t('utils.meeting'),
      color: '#E0BED2',
      url: 'theme-s-4.png',
      background: 'theme-l-4.png'
    }, // 会议
    {
      id: 5,
      text: _i18n.t('utils.up'),
      color: '#B9CAD8',
      url: 'theme-s-5.png',
      background: 'theme-l-5.png'
    }, // 向上
    {
      id: 6,
      text: _i18n.t('utils.administration'),
      color: '#C2E7FF',
      url: 'theme-s-6.png',
      background: 'theme-l-6.png'
    }, // 行政
    {
      id: 7,
      text: _i18n.t('utils.quwei'),
      color: '#FFCBBC',
      url: 'theme-s-7.png',
      background: 'theme-l-7.png'
    }, // 趣味
    {
      id: 8,
      text: _i18n.t('utils.silent'),
      color: '#D1D6EB',
      url: 'theme-s-8.png',
      background: 'theme-l-8.png'
    }, // 寂静
    {
      id: 9,
      text: _i18n.t('utils.dushi'),
      color: '#D2CCEA',
      url: 'theme-s-9.png',
      background: 'theme-l-9.png'
    }, // 都市
    {
      id: 10,
      text: _i18n.t('utils.qinliang'),
      color: '#B4F2FA',
      url: 'theme-s-10.png',
      background: 'theme-l-10.png'
    }, // 清凉
    {
      id: 11,
      text: _i18n.t('utils.menghuan'),
      color: '#C6EBFF',
      url: 'theme-s-11.png',
      background: 'theme-l-11.png'
    }, // 梦幻
    {
      id: 12,
      text: _i18n.t('utils.richu'),
      color: '#E0BED2',
      url: 'theme-s-12.png',
      background: 'theme-l-12.png'
    }, // 日出
    {
      id: 13,
      text: _i18n.t('utils.chuxia'),
      color: '#FFF9E8',
      url: 'theme-s-13.png',
      background: 'theme-l-13.png'
    }, // 初夏
    {
      id: 14,
      text: _i18n.t('utils.reqing'),
      color: '#FBE6D6',
      url: 'theme-s-14.png',
      background: 'theme-l-14.png'
    }, // 热情
    {
      id: 15,
      text: _i18n.t('utils.yaoyuan'),
      color: '#E0C6BE',
      url: 'theme-s-15.png',
      background: 'theme-l-15.png'
    }, // 遥远
    {
      id: 16,
      text: _i18n.t('utils.shenye'),
      color: '#CCDCEA',
      url: 'theme-s-16.png',
      background: 'theme-l-16.png'
    }, // 夜深
    {
      id: 17,
      text: _i18n.t('utils.work'),
      color: '#E8F3FF',
      url: 'theme-s-17.png',
      background: 'theme-l-17.png'
    } // 工作
  ]
}
// 主题外观(门户)
const wthemes = function () {
  return [
    { id: 0, text: _i18n.t('workbench.empty'), color: '#CFE7FA', url: '', background: '' }, // 休闲
    {
      id: 1,
      text: _i18n.t('workbench.background') + '1',
      color: '#E1FCF9 ',
      url: 'bg_01.jpg',
      background: 'bg_01.jpg'
    },
    {
      id: 2,
      text: _i18n.t('workbench.background') + '2',
      color: '#D1D6EB',
      url: 'bg_02.jpg',
      background: 'bg_02.jpg'
    },
    {
      id: 3,
      text: _i18n.t('workbench.background') + '3',
      color: '#F4EEDB',
      url: 'bg_03.jpg',
      background: 'bg_03.jpg'
    },
    {
      id: 4,
      text: _i18n.t('workbench.background') + '4',
      color: '#E0BED2',
      url: 'bg_04.jpg',
      background: 'bg_04.jpg'
    },
    {
      id: 5,
      text: _i18n.t('workbench.background') + '5',
      color: '#B9CAD8',
      url: 'bg_05.jpg',
      background: 'bg_05.jpg'
    },
    {
      id: 6,
      text: _i18n.t('workbench.background') + '6',
      color: '#C2E7FF',
      url: 'bg_06.jpg',
      background: 'bg_06.jpg'
    },
    {
      id: 7,
      text: _i18n.t('workbench.background') + '7',
      color: '#FFCBBC',
      url: 'bg_07.jpg',
      background: 'bg_07.jpg'
    },
    {
      id: 8,
      text: _i18n.t('workbench.background') + '8',
      color: '#FFCBBC',
      url: 'bg_08.jpg',
      background: 'bg_08.jpg'
    },
    {
      id: 9,
      text: _i18n.t('workbench.background') + '9',
      color: '#FFCBBC',
      url: 'bg_09.jpg',
      background: 'bg_09.jpg'
    }
  ]
}
/** 正则 */
/* eslint-disable */
const regular = {
  ip: /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])(\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])){3}$/ /* IP */,
  ipRegularJUdge:
    /^(http|ftp|https):\/\/(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])(\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])){3}$/ /* IP */,
  port: /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{4}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/,
  pattIp:
    /^(http|ftp|https):\/\/(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\:([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5])$/,
  domain: /^((https?|ftp|file):\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
  domain2:
    /^((https?|ftp|file):\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)(:([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5])){0,1}$/,
  phone: new RegExp('^1[3,4,5,6,7,8,9]\\d{9}$'),
  pwdRegx:
    /^[a-zA-Z0-9`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]{6,18}$/,
  externalPwd: /^[0-9A-Za-z]{6,18}$/,
  email: /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/,
  idcard:
    /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
  reg1: /^([1-9]\d*|[0]{1,1})$/, // 含0正整数
  reg2: /^[1-9]+\d*$/, // 不含0正整数
  mac: /([A-Fa-f0-9]{2}([:|-])){5}[A-Fa-f0-9]{2}$/, // MAC
  pwdRegx0: /[\s\S]/,
  pwdRegx1: /[A-Za-z0-9]/,
  decimal2: /^\d+(\.\d{0,2})?$/, // 两位小数
  pwdRegx2: /[\s\S]/,
  pwdRegx3: /[\s\S]/,
  pwdRegx4: /[\s\S]/
}
// 任务自定义默认7个字段 (不需要国际化)
const taskDefaultFields = [
  {
    name: 'default_name',
    label: '名称',
    type: 'text',
    typeText: '单行文本',
    width: '100%',
    state: '1',
    remove: '0',
    active: '0',
    field: {
      fieldControl: '2', // 字段控制('0'都不选 1只读 2必填)
      addView: '1', // 新增显示
      editView: '1', // 编辑显示
      structure: '1', // 结构(0上下布局 1左右布局)
      pointOut: _i18n.t('base_common.placeholder.input'), // '请输入', // 提示框
      repeatCheck: '0', // 查重(0不查重 1允许保存 2不允许保存)
      terminalPc: '1', // PC终端
      terminalApp: '1', // APP终端
      defaultValue: '',
      isShowCard: '0', // 是否展示任务卡片(0 不显示，1 显示)
      isFillReason: '0' // 激活原因(0 不填写，1 填写)
    }
  },
  {
    name: 'default_reference', // 英文名称
    label: '关联', // 中文名称
    type: 'reference', // 组件类型
    typeText: '关联关系', // 组件类型描述
    width: '100%', // 组件宽度
    state: '0', // 组件启禁用
    remove: '0', // 可移除组件
    active: '0', // 是否选中
    field: {
      fieldControl: '0', // 字段控制(0都不选 1只读 2必填)
      addView: '1', // 新增显示
      editView: '1', // 编辑显示
      pointOut: _i18n.t('base_common.placeholder.input'), // '请输入', // 提示框
      structure: '1', // 结构(0上下布局 1左右布局)
      isShowCard: '0', // 是否展示任务卡片(0 不显示，1 显示)
      isFillReason: '0' // 激活原因(0 不填写，1 填写)
    },
    relevanceModule: {
      // 关联模块
      moduleLabel: '##', // 关联模块中文名称
      moduleName: '##' // 关联模块英文名称
    },
    relevanceField: {
      // 关联字段
      fieldLabel: '##', // 关联字段中文名称
      fieldName: '##' // 关联字段英文名称
    },
    searchFields: [
      // 搜索字段
      {
        fieldLabel: '##', // 搜索字段中文名称
        fieldName: '##' // 搜索字段英文名称
      }
    ],
    relevanceWhere: [
      // 关联筛选条件
      {
        fieldLabel: '', // 条件字段中文名称
        fieldName: '', // 条件字段英文名称
        operatorType: '', // 条件运算符
        value: '' // 条件匹配值
      }
    ],
    seniorWhere: '1 AND 2'
  },
  {
    name: 'default_tag', // 英文名称
    label: '标签', // 中文名称
    type: 'tag', // 组件类型
    typeText: '下拉选项', // 组件类型描述
    width: '100%', // 组件宽度
    remove: '0', // 可移除组件
    field: {
      fieldControl: '0',
      structure: '1' // 结构(0上下布局 1左右布局)
    }
  },
  {
    name: 'richtext' + new Date().getTime() + '0', // 英文名称
    label: '描述', // 中文名称
    type: 'richtext', // 组件类型
    typeText: '富文本', // 组件类型描述
    width: '100%', // 组件宽度
    state: '0', // 组件启禁用
    remove: '1', // 可移除组件
    active: '0', // 是否选中
    field: {
      fieldControl: '0', // 字段控制(0都不选 1只读 2必填)
      addView: '1', // 新增显示
      editView: '1', // 编辑显示
      structure: '1', // 结构(0上下布局 1左右布局)
      pointOut: _i18n.t('base_common.placeholder.input'), // '请输入', // 提示框
      repeatCheck: '0', // 查重(0不查重 1允许保存 2不允许保存)
      defaultValue: '', // 默认值
      isShowCard: '0', // 是否展示任务卡片(0 不显示，1 显示)
      isFillReason: '0' // 激活原因(0 不填写，1 填写)
    }
  },
  {
    name: 'default_executor', // 英文名称
    label: '执行人', // 中文名称
    type: 'personnel', // 组件类型
    typeText: '人员', // 组件类型描述
    width: '50%', // 组件宽度
    state: '0', // 组件启禁用
    remove: '0', // 可移除组件
    active: '0', // 是否选中
    field: {
      chooseType: '0', // 选择类型：0单选、1多选
      defaultPersonnel: [
        // 默认人员
        // 人员对象
      ],
      chooseRange: [
        // 可选范围(公司:gs_id、部门:bm_id、人员:ry_id)
        // 范围对象
      ],
      structure: '1', // 结构
      fieldControl: '0', // 字段控制(0都不选 1只读 2必填)
      addView: '1', // 新增显示
      editView: '1' // 编辑显示
    }
  },
  {
    name: 'default_deadline', // 英文名称
    label: '截止时间', // 中文名称
    type: 'datetime', // 组件类型
    typeText: '日期时间', // 组件类型描述
    width: '50%', // 组件宽度
    state: '0', // 组件启禁用
    remove: '0', // 可移除组件
    active: '0', // 是否选中
    field: {
      datetimeType: 'YYYY-MM-DD', // 日期格式
      defaultValueId: '', // 默认值
      defaultValue: '', // 默认值
      structure: '1', // 结构
      fieldControl: '0', // 字段控制(0都不选 1只读 2必填)
      addView: '1', // 新增显示
      editView: '1' // 编辑显示
    }
  },
  {
    name: 'attachment_' + new Date().getTime() + '1', // 英文名称
    label: '附件', // 中文名称
    type: 'attachment', // 组件类型
    typeText: '附件', // 组件类型描述
    width: '100%', // 组件宽度
    state: '1', // 组件启禁用
    remove: '1', // 可移除组件
    active: '0', // 是否选中
    field: {
      fieldControl: '0', // 字段控制(0都不选 1只读 2必填)
      addView: '1', // 新增显示
      editView: '1', // 编辑显示
      structure: '1', // 结构(0上下布局 1左右布局)
      countLimit: '0', // 数量限制(0不限制 1限制)
      maxCount: '#max#', // 最大上传数
      maxSize: '#max#' // 最大上传大小
    }
  }
]
const TFParameter = {
  website: 'https://www.huijuhuaqi.com',
  help: 'https://www.teamface.cn/help/document/',
  TEAMFACEPWD: 'hjhq2017Teamface',
  qd: 'https://qd.teamface.cn/caozuozhinan/76.html', // 帮助文档
  jszc:
    process.env.VUE_APP_ADDRESS_WEB_FORM +
    '/#/fZFun8QuU.fZFun8QuU.73.28.bean1584683732610.1.teamface_id', // 技术支持
  gxrz: 'https://www.teamface.cn/help/log/', // 更新日志
  tsjy:
    process.env.VUE_APP_ADDRESS_WEB_FORM +
    '/#/PB2FXgZbK.PB2FXgZbK.73.28.bean1529575710113.1.teamface_id', // 投诉建议
  pingj:
    process.env.VUE_APP_ADDRESS_WEB_FORM +
    '/#/QZq4nugZE.QZq4nugZE.73.28.bean1584256974185.1.teamface_id', // 产品评价
  dz:
    process.env.VUE_APP_ADDRESS_WEB_FORM +
    '/#/LuwabA4Sb.LuwabA4Sb.73.28.bean1584933253165.2.teamface_id', // 定制应用
  asd: 'asd', // asd
  asd: 'asd' // asd
}
// web表单辅助组件、
const webformComponents = function () {
  return [
    {
      name: 'default_name',
      label: _i18n.t('custom_backstage.picturedisplay'),
      type: 'imageShow',
      typeText: _i18n.t('custom_backstage.textDesc'),
      icon: 'icon-portal-tupian',
      count: '1',
      imageList: [{ imageUrl: '', isJumpUrl: false, jumpUrl: '' }]
    },
    {
      name: 'default_name',
      label: _i18n.t('custom_backstage.pictureCarousel'),
      type: 'imagecarousel',
      typeText: _i18n.t('custom_backstage.textDesc'),
      icon: 'icon-portal-lunbotu',
      imageList: [{ imageUrl: '', isJumpUrl: false, jumpUrl: '' }],
      duration: '3s',
      height: '200px'
    },
    {
      name: 'default_name',
      label: _i18n.t('custom_backstage.videoShow'),
      type: 'video',
      typeText: _i18n.t('custom_backstage.textDesc'),
      icon: 'icon-portal-shipin',
      url: ''
    },
    {
      name: 'default_name',
      label: _i18n.t('custom_backstage.textDesc'),
      type: 'description',
      typeText: _i18n.t('custom_backstage.textDesc'),
      icon: 'icon-fuwenben',
      text: ''
    },
    {
      name: 'default_name',
      label: _i18n.t('custom_backstage.button'),
      type: 'button',
      typeText: _i18n.t('custom_backstage.textDesc'),
      icon: 'icon-webform-button',
      fields: {
        text: '',
        color: '',
        fontSize: '',
        bold: false,
        icon: '',
        radius: '1px',
        height: '',
        width: 'auto/15px',
        widthType: '0'
      },
      position: '',
      event: { value: '1', label: _i18n.t('custom_backstage.jumpLink') }, // 0 无， 1， 跳转链接， 2 拨打电话 3 发短信， 4 发邮件
      eventText: '',
      styleType: '0' // 0 默认，1 自定义
    },
    {
      name: 'default_name',
      label: _i18n.t('custom_backstage.staticMap'),
      type: 'staticMap',
      typeText: _i18n.t('custom_backstage.textDesc'),
      icon: 'icon-webform-map',
      address: '',
      isMarkMsg: false,
      markMsg: '',
      scale: ''
    },
    {
      name: 'default_name',
      label: _i18n.t('custom_backstage.timer'),
      type: 'timer',
      typeText: _i18n.t('custom_backstage.textDesc'),
      icon: 'icon-webform-timer',
      form: { value: '0', label: _i18n.t('custom_backstage.jishi') },
      formatType: { value: '0', label: _i18n.t('base_common.day2') },
      initialTime: '',
      arrivalTime: ''
    },
    {
      name: 'default_name',
      label: _i18n.t('custom_backstage.form'),
      type: 'form',
      typeText: _i18n.t('custom_backstage.form'),
      icon: 'icon-webform-form',
      submitArea: { field: {} },
      componentList: []
    },
    {
      name: 'default_name',
      label: _i18n.t('custom_backstage.splitLine'),
      type: 'splitLine',
      typeText: _i18n.t('custom_backstage.splitLine'),
      icon: 'icon-divider',
      fields: {
        lineType: '', // solid: 实线， dashed：虚线，dotted，点画线，double 双实线
        lineColor: '#000',
        lineWidth: '1px'
      }
    },
    {
      name: 'default_name',
      label: _i18n.t('custom_backstage.GetSssociatedModuleValue'), // '获取关联模块值',
      type: 'relation',
      typeText: _i18n.t('custom_backstage.GetSssociatedModuleValue'), // '获取关联模块值',
      icon: 'icon-webform-form',
      submitArea: { field: {} },
      componentList: []
    }
    // {
    //   name: 'default_name',
    //   label: '评分',
    //   type: 'rate',
    //   typeText: '评分',
    //   icon: 'icon-portal-tupian'
    // },
    // {
    //   name: 'default_name',
    //   label: '投票',
    //   type: 'vote',
    //   typeText: '投票',
    //   icon: 'icon-portal-tupian',
    //   fields: {
    //     fieldControl: '2'
    //   },
    //   imageList: []
    // }
  ]
}

/** 行业 */
const appIndustry = function () {
  return {
    industry: [
      { id: 1, label: _i18n.t('utils.B2cPlatform') }, // '电商平台'},
      { id: 2, label: _i18n.t('utils.ITInternet') }, // 'IT互联网'},
      { id: 3, label: _i18n.t('utils.teachTrain') }, // '教育培训'},
      { id: 4, label: _i18n.t('utils.houseCenter') }, // '房产中介'},
      { id: 5, label: _i18n.t('utils.jinrongBaoxian') }, // '金融保险'},
      { id: 6, label: _i18n.t('utils.wuliuYunshu') }, // '物流运输'},
      { id: 7, label: _i18n.t('utils.jiazhengFuwu') }, // '家政服务'},
      { id: 8, label: _i18n.t('utils.qicheFuwu') }, // '汽车服务'},
      { id: 9, label: _i18n.t('utils.yiliaoZhiyao') }, // '医疗制药'},
      { id: 10, label: _i18n.t('utils.lvshiAnjian') }, // '律师案件'},
      { id: 11, label: _i18n.t('utils.nonglinye') }, // '农林牧渔业'},
      { id: 12, label: _i18n.t('utils.guangaoMeiti') }, // '广告媒体'},
      { id: 13, label: _i18n.t('utils.other') } // '其他'}
    ],
    classification: [
      { id: 1, label: _i18n.t('utils.xingzhengBangong') }, // '行政办公'},
      { id: 2, label: _i18n.t('utils.renliZiyuan') }, // '人力资源'},
      { id: 3, label: _i18n.t('utils.kehuGuanli') }, // '客户管理'},
      { id: 4, label: _i18n.t('utils.huiyuanGuanli') }, // '会员管理'},
      { id: 5, label: _i18n.t('utils.shouhouGuanli') }, // '售后管理'},
      { id: 6, label: _i18n.t('utils.jinxiaocun') }, // '进销存'},
      { id: 7, label: _i18n.t('utils.cangkuGuanli') }, // '仓储管理'},
      { id: 8, label: _i18n.t('utils.other') } // '其他'}
    ]
  }
}
// 二维码样式编号
const barcodeStyleList = [
  { bgImg: 'CODE39.png', code: 'CODE 39' },
  { bgImg: 'CODE128.png', code: 'CODE 128' },
  { bgImg: 'CODABAR.png', code: 'CODABAR' },
  { bgImg: 'EAN8.png', code: 'EAN 8' },
  { bgImg: 'EAN13.png', code: 'EAN 13' },
  { bgImg: 'EAN128.png', code: 'EAN128' },
  { bgImg: 'UPC-A.png', code: 'UPC-A' },
  { bgImg: 'UPC-E.png', code: 'UPC-E' },
  { bgImg: 'PostNet.png', code: 'PostNet' },
  { bgImg: 'ITF-14.png', code: 'ITF-14' },
  { bgImg: 'Interleaved2of5.png', code: 'Interleaved 2of5' },
  { bgImg: 'PDF417.png', code: 'PDF417' },
  { bgImg: 'DataMatrix.png', code: 'Data Matrix' }
]
// 常用字段 (不需要国际化，后台返回)
const commonField = [
  {
    name: 'text_',
    label: '公司名称',
    type: 'text',
    typeText: '单行文本',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-danhangwenben',
    isDrag: true,
    field: {
      fieldControl: '2',
      addView: '1',
      editView: '1',
      structure: '1',
      pointOut: '',
      repeatCheck: '2',
      terminalPc: '1',
      terminalApp: '1',
      defaultValue: ''
    }
  },
  {
    name: 'text_',
    label: '姓名',
    type: 'text',
    typeText: '单行文本',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-danhangwenben',
    isDrag: true,
    field: {
      fieldControl: '0',
      addView: '1',
      editView: '1',
      structure: '1',
      pointOut: '',
      repeatCheck: '0',
      terminalPc: '1',
      terminalApp: '1',
      defaultValue: ''
    }
  },
  {
    name: 'phone_',
    label: '电话',
    type: 'phone',
    typeText: '电话',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-dianhua',
    isDrag: true,
    field: {
      fieldControl: '0',
      addView: '1',
      editView: '1',
      structure: '1',
      pointOut: '',
      phoneType: '0',
      phoneLenth: '0',
      repeatCheck: '0',
      terminalPc: '1',
      terminalApp: '1'
    }
  },
  {
    name: 'picklist_',
    label: '行业',
    type: 'picklist',
    typeText: '下拉选项',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-xialaxuanxiang',
    isDrag: true,
    field: {
      fieldControl: '0',
      addView: '1',
      editView: '1',
      structure: '1',
      chooseType: '0',
      terminalPc: '1',
      terminalApp: '1',
      defaultEntrys: []
    },
    entrys: [
      {
        value: '0',
        label: '金融',
        color: '#FFFFFF'
      },
      {
        value: '1',
        label: '咨询',
        color: '#FFFFFF'
      },
      {
        value: '2',
        label: '娱乐',
        color: '#FFFFFF'
      },
      {
        value: '3',
        label: '媒体',
        color: '#FFFFFF'
      },
      {
        value: '4',
        label: '零售',
        color: '#FFFFFF'
      },
      {
        value: '5',
        label: '能源',
        color: '#FFFFFF'
      },
      {
        value: '6',
        label: '服务',
        color: '#FFFFFF'
      },
      {
        value: '7',
        label: '制造业',
        color: '#FFFFFF'
      },
      {
        value: '8',
        label: '通讯',
        color: '#FFFFFF'
      },
      {
        value: '9',
        label: '酒店',
        color: '#FFFFFF'
      },
      {
        value: '10',
        label: '保险',
        color: '#FFFFFF'
      },
      {
        value: '11',
        label: '银行',
        color: '#FFFFFF'
      },
      {
        value: '12',
        label: '服装',
        color: '#FFFFFF'
      },
      {
        value: '13',
        label: '政府',
        color: '#FFFFFF'
      },
      {
        value: '14',
        label: '高科技',
        color: '#FFFFFF'
      },
      {
        value: '15',
        label: '教育',
        color: '#FFFFFF'
      },
      {
        value: '16',
        label: '电信',
        color: '#FFFFFF'
      },
      {
        value: '17',
        label: '公共事业',
        color: '#FFFFFF'
      },
      {
        value: '18',
        label: '非盈利事业',
        color: '#FFFFFF'
      },
      {
        value: '19',
        label: '其它',
        color: '#FFFFFF'
      }
    ]
  },
  {
    name: 'text_',
    label: 'QQ',
    type: 'text',
    typeText: '单行文本',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-danhangwenben',
    isDrag: true,
    field: {
      fieldControl: '0',
      addView: '1',
      editView: '1',
      structure: '1',
      pointOut: '',
      repeatCheck: '0',
      terminalPc: '1',
      terminalApp: '1',
      defaultValue: ''
    }
  },
  {
    name: 'picklist_',
    label: '客户级别',
    type: 'picklist',
    typeText: '下拉选项',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-xialaxuanxiang',
    isDrag: true,
    field: {
      fieldControl: '0',
      addView: '1',
      editView: '1',
      structure: '1',
      chooseType: '0',
      terminalPc: '1',
      terminalApp: '1',
      defaultEntrys: []
    },
    entrys: [
      {
        value: '0',
        label: 'A(非常重要)',
        color: '#FFFFFF'
      },
      {
        value: '1',
        label: 'B(重要)',
        color: '#FFFFFF'
      },
      {
        value: '2',
        label: 'C(一般)',
        color: '#FFFFFF'
      }
    ]
  },
  {
    name: 'phone_',
    label: '手机号码',
    type: 'phone',
    typeText: '电话',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-dianhua',
    isDrag: true,
    field: {
      fieldControl: '2',
      addView: '1',
      editView: '1',
      structure: '1',
      pointOut: '',
      phoneType: '1',
      phoneLenth: '1',
      repeatCheck: '2',
      terminalPc: '1',
      terminalApp: '1'
    }
  },
  {
    name: 'email_',
    label: '电子邮箱',
    type: 'email',
    typeText: '电子邮箱',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-youxiang',
    isDrag: true,
    field: {
      pointOut: '',
      structure: '1',
      fieldControl: '0',
      addView: '1',
      editView: '1',
      repeatCheck: '0',
      terminalPc: '1',
      terminalApp: '1'
    }
  },
  {
    name: 'department_',
    label: '部门',
    type: 'department',
    typeText: '部门',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-bumen',
    isDrag: true,
    field: {
      chooseType: '0',
      defaultDepartment: [],
      chooseRange: [],
      structure: '1',
      fieldControl: '0',
      addView: '1',
      editView: '1',
      terminalPc: '1',
      terminalApp: '1'
    }
  },
  {
    name: 'text_',
    label: '职位',
    type: 'text',
    typeText: '单行文本',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-danhangwenben',
    isDrag: true,
    field: {
      fieldControl: '0',
      addView: '1',
      editView: '1',
      structure: '1',
      pointOut: '',
      repeatCheck: '0',
      terminalPc: '1',
      terminalApp: '1',
      defaultValue: ''
    }
  },
  {
    name: 'picklist_',
    label: '性别',
    type: 'picklist',
    typeText: '下拉选项',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-xialaxuanxiang',
    isDrag: true,
    field: {
      fieldControl: '0',
      addView: '1',
      editView: '1',
      structure: '1',
      chooseType: '0',
      terminalPc: '1',
      terminalApp: '1',
      defaultEntrys: []
    },
    entrys: [
      {
        value: '0',
        label: '男',
        color: '#FFFFFF'
      },
      {
        value: '1',
        label: '女',
        color: '#FFFFFF'
      },
      {
        value: '2',
        label: '未知',
        color: '#FFFFFF'
      }
    ]
  },
  {
    name: 'location_',
    label: '地址',
    type: 'location',
    typeText: '定位',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-dingwei',
    isDrag: true,
    field: {
      fieldControl: '0',
      addView: '1',
      editView: '1',
      structure: '1',
      pointOut: '',
      terminalPc: '1',
      terminalApp: '1',
      defaultValue: '1'
    }
  },
  {
    name: 'text_',
    label: '传真',
    type: 'text',
    typeText: '单行文本',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-danhangwenben',
    isDrag: true,
    field: {
      fieldControl: '0',
      addView: '1',
      editView: '1',
      structure: '1',
      pointOut: '',
      repeatCheck: '0',
      terminalPc: '1',
      terminalApp: '1',
      defaultValue: ''
    }
  },
  {
    name: 'text_',
    label: '微信',
    type: 'text',
    typeText: '单行文本',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-danhangwenben',
    isDrag: true,
    field: {
      fieldControl: '0',
      addView: '1',
      editView: '1',
      structure: '1',
      pointOut: '',
      repeatCheck: '0',
      terminalPc: '1',
      terminalApp: '1',
      defaultValue: ''
    }
  },
  {
    name: 'datetime_',
    label: '开始日期',
    type: 'datetime',
    typeText: '日期/时间',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-riqishijian',
    isDrag: true,
    field: {
      formatType: 'yyyy-MM-dd',
      defaultValueId: '0',
      defaultValue: '',
      structure: '1',
      fieldControl: '0',
      addView: '1',
      editView: '1',
      terminalPc: '1',
      terminalApp: '1'
    }
  },
  {
    name: 'datetime_',
    label: '结束日期',
    type: 'datetime',
    typeText: '日期/时间',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-riqishijian',
    isDrag: true,
    field: {
      formatType: 'yyyy-MM-dd',
      defaultValueId: '0',
      defaultValue: '',
      structure: '1',
      fieldControl: '0',
      addView: '1',
      editView: '1',
      terminalPc: '1',
      terminalApp: '1'
    }
  },
  {
    name: 'picklist_',
    label: '优先级',
    type: 'picklist',
    typeText: '下拉选项',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-xialaxuanxiang',
    isDrag: true,
    field: {
      fieldControl: '0',
      addView: '1',
      editView: '1',
      structure: '1',
      chooseType: '0',
      terminalPc: '1',
      terminalApp: '1',
      defaultEntrys: []
    },
    entrys: [
      {
        value: '0',
        label: '高',
        color: '#FFFFFF'
      },
      {
        value: '1',
        label: '中',
        color: '#FFFFFF'
      },
      {
        value: '2',
        label: '低',
        color: '#FFFFFF'
      }
    ]
  },
  {
    name: 'picklist_',
    label: '跟进状态',
    type: 'picklist',
    typeText: '下拉选项',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-xialaxuanxiang',
    isDrag: true,
    field: {
      fieldControl: '0',
      addView: '1',
      editView: '1',
      structure: '1',
      chooseType: '0',
      terminalPc: '1',
      terminalApp: '1',
      defaultEntrys: [
        {
          value: '0',
          label: '初步沟通',
          color: '#FFFFFF'
        }
      ]
    },
    entrys: [
      {
        value: '0',
        label: '初步沟通',
        color: '#FFFFFF'
      },
      {
        value: '1',
        label: '见面拜访',
        color: '#FFFFFF'
      },
      {
        value: '2',
        label: '确定意向',
        color: '#FFFFFF'
      },
      {
        value: '3',
        label: '商务洽谈',
        color: '#FFFFFF'
      },
      {
        value: '4',
        label: '正式报价',
        color: '#FFFFFF'
      },
      {
        value: '5',
        label: '签约合作',
        color: '#FFFFFF'
      },
      {
        value: '6',
        label: '停滞客户',
        color: '#FFFFFF'
      },
      {
        value: '7',
        label: '流失客户',
        color: '#FFFFFF'
      }
    ]
  },
  {
    name: 'picklist_',
    label: '来源',
    type: 'picklist',
    typeText: '下拉选项',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-xialaxuanxiang',
    isDrag: true,
    field: {
      fieldControl: '0',
      addView: '1',
      editView: '1',
      structure: '1',
      chooseType: '0',
      terminalPc: '1',
      terminalApp: '1',
      defaultEntrys: []
    },
    entrys: [
      {
        value: '0',
        label: '媒体-广告',
        color: '#FFFFFF'
      },
      {
        value: '1',
        label: '外部推荐',
        color: '#FFFFFF'
      },
      {
        value: '2',
        label: '关键字',
        color: '#FFFFFF'
      },
      {
        value: '3',
        label: '研讨会-内部',
        color: '#FFFFFF'
      },
      {
        value: '4',
        label: '员工推荐',
        color: '#FFFFFF'
      },
      {
        value: '5',
        label: '研讨会-合作伙伴',
        color: '#FFFFFF'
      },
      {
        value: '6',
        label: '直接邮件',
        color: '#FFFFFF'
      },
      {
        value: '7',
        label: '展览会',
        color: '#FFFFFF'
      },
      {
        value: '8',
        label: '公共关系',
        color: '#FFFFFF'
      },
      {
        value: '9',
        label: '合作伙伴',
        color: '#FFFFFF'
      },
      {
        value: '10',
        label: '其它',
        color: '#FFFFFF'
      }
    ]
  },
  {
    name: 'picklist_',
    label: '省',
    type: 'picklist',
    typeText: '下拉选项',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-xialaxuanxiang',
    isDrag: true,
    field: {
      commonlyArea: '1',
      fieldControl: '0',
      addView: '1',
      editView: '1',
      structure: '1',
      chooseType: '0',
      terminalPc: '1',
      terminalApp: '1',
      defaultEntrys: []
    },
    entrys: []
  },
  {
    name: 'picklist_',
    label: '市',
    type: 'picklist',
    typeText: '下拉选项',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-xialaxuanxiang',
    isDrag: true,
    field: {
      commonlyArea: '2',
      fieldControl: '0',
      addView: '1',
      editView: '1',
      structure: '1',
      chooseType: '0',
      terminalPc: '1',
      terminalApp: '1',
      defaultEntrys: []
    },
    entrys: []
  },
  {
    name: 'picklist_',
    label: '区',
    type: 'picklist',
    typeText: '下拉选项',
    width: '50%',
    state: '0',
    remove: '1',
    icon: 'icon-xialaxuanxiang',
    isDrag: true,
    field: {
      commonlyArea: '3',
      fieldControl: '0',
      addView: '1',
      editView: '1',
      structure: '1',
      chooseType: '0',
      terminalPc: '1',
      terminalApp: '1',
      defaultEntrys: []
    },
    entrys: []
  }
]

// 组件type名称
const assembly = {
  TEXT: 'text', // 文本
  PERSONNEL: 'personnel', // 人员
  TEXTAREA: 'textarea', // 多行文本
  MULTITEXT: 'multitext', // 富文本
  PICKLIST: 'picklist', // 下拉
  PHONE: 'phone', // 电话
  EMAIL: 'email', // 邮箱
  NUMBER: 'number', // 数字
  DATETIME: 'datetime', // 时间
  ATTACHMENT: 'attachment', // 附件
  PICTURE: 'picture', // 图片
  LOCATION: 'location', // 定位
  URL: 'url', // 超链接
  MULTI: 'multi', // 复选框
  DEPARTMENT: 'department', // 部门
  MULTIPICKLIST: 'mutlipicklist', // 多级下拉
  FORMULA: 'formula', // 简单公式
  AREA: 'area', // 省市区
  IDENTIFIER: 'identifier', // 自动编号
  SERIALNUM: 'serialnum', // 流水号
  REFERENCE: 'reference', // 关联关系
  SUBFORM: 'subform', // 子表单
  FUNCFORMULA: 'functionformula', // 函数公式
  SENIORFORMULA: 'seniorformula', // 高级公式
  BARCODE: 'barcode', // 条形码
  CITEFORMULA: 'citeformula' // 引用公式组件
}

// 人事：组织管理 员工管理 考勤中心 薪酬管理 人才管理 绩效考核
// 运营：包含审批中心、数据分析、邮件、备忘录、知识文档、自定义应用名称
const systemModule = function () {
  let appList = [
    // 企典OKR
    {
      chinese_name: _i18n.t('okr.teamface_okr'),
      english_name: 'okr',
      icon_url: 'icon-qidianOKR',
      icon_url2: 'icon-qidianOKR',
      icon_color: '#5583FE',
      path: 'TeamfaceMyOkr',
      status: 0,
      id: ''
    },
    // 组织管理
    {
      chinese_name: _i18n.t('okr.Organization'),
      english_name: 'hr_org',
      icon_url: 'icon-liucheng5',
      icon_url2: 'icon-xuanrenkongjian-icon',
      icon_color: '#2F96F9',
      status: 0,
      id: '',
      path: 'OrganizationalStructure'
    },
    // 员工管理
    {
      chinese_name: _i18n.t('okr.Employee'),
      english_name: 'hr_employee',
      icon_url: 'icon-staff',
      icon_url2: 'icon-staff',
      icon_color: '#2CC6D0',
      path: 'StaffRoster',
      status: 0,
      id: ''
    },
    // 考勤
    {
      chinese_name: _i18n.t('base_common.attendance'),
      english_name: 'attendance',
      icon_url: 'icon-icon-nav-attendance',
      icon_url2: 'icon-icon-nav-attendance-o',
      icon_color: '#D97978',
      path: 'AttendanceDay',
      status: 0,
      id: ''
    },
    // 绩效管理
    {
      chinese_name: _i18n.t('okr.base_setting_tip_35'),
      english_name: 'achievement',
      icon_url: 'icon-performance',
      icon_url2: 'icon-performance',
      icon_color: '#FA5A7D',
      path: 'Performance',
      status: 0,
      id: ''
    },
    // 薪酬
    {
      chinese_name: _i18n.t('okr.Salary'),
      english_name: 'hr_salary',
      icon_url: 'icon-salary',
      icon_url2: 'icon-salary-o',
      icon_color: '#FFA416',
      path: 'MonthlySalarySheet',
      status: 0,
      id: ''
    },
    // 审批
    {
      chinese_name: _i18n.t('base_common.approval'),
      english_name: 'approval',
      icon_url: 'icon-shenpi',
      icon_url2: 'icon-shenpi-o',
      icon_color: '#FFA416',
      path: 'Approval',
      status: 0,
      id: ''
    },
    // 数据分析
    {
      chinese_name: _i18n.t('custom.manageCockpit'),
      english_name: 'analysis',
      icon_url: 'icon-system-library-3',
      icon_url2: 'icon-system-library-3-b',
      icon_color: '#4888FF',
      path: 'definedReport',
      status: 0,
      id: ''
    },
    // 邮件
    {
      chinese_name: _i18n.t('base_common.email'),
      english_name: 'email',
      icon_url: 'icon-youjian1',
      icon_url2: 'icon-youjian',
      icon_color: '#43C535',
      path: 'EmailMain',
      status: 0,
      id: ''
    },
    // 备忘录
    {
      chinese_name: _i18n.t('base_common.memo'),
      english_name: 'memo',
      icon_url: 'icon-system-library-4',
      icon_url2: 'icon-system-library-4-b',
      icon_color: '#2CCCDA',
      path: 'Memo',
      status: 0,
      id: ''
    },
    // 知识库
    {
      chinese_name: _i18n.t('base_common.knowledgeDoc'),
      english_name: 'knowledge_document',
      icon_url: 'icon-nav-knowledge',
      icon_url2: 'icon-nav-knowledge-o',
      icon_color: '#FC587B',
      path: 'KnowledgeDocument',
      status: 0,
      id: ''
    },
    // 人才管理
    {
      chinese_name: '人才管理',
      english_name: 'talent_management',
      icon_url: 'icon-staff',
      icon_url2: 'icon-staff',
      icon_color: '#1890ff',
      path: 'TalentCompetencyDictionary',
      status: 0,
      id: ''
    },
    // 公文管理
    {
      chinese_name: '公文管理',
      english_name: 'official_document',
      icon_url: 'icon-portal-btn-10',
      icon_url2: 'icon-portal-btn-10',
      icon_color: '#2780F7',
      path: 'DocumentSendDraft',
      status: 0,
      id: ''
    }
  ]
  // 是否打开协作
  if (window.show_project_app) {
    let objproject = {
      chinese_name: _i18n.t('base_common.project'),
      english_name: 'project',
      icon_url: 'icon-nav-project',
      icon_url2: 'icon-nav-project-o',
      icon_color: '#FC587B',
      path: 'ProjectList',
      status: 0,
      id: ''
    }
    appList.splice(4, 0, objproject)
  }
  return appList
}

// 工作台组件
// 自定义组件 custom
// 系统组件 system
// {'type': 'project', 'name': '协作', 'properties': {'x': 0, 'y': 0, 'w': 50, 'h': 415}},
const workbench = {
  custom: [
    // 子菜单
    {
      type: 'subMenu',
      name: _i18n.t('utils.subMenu'),
      properties: { x: 0, y: 0, w: 50, h: 415 },
      pageInfo: { pageNum: 1, pageSize: 5 }
    },
    // 视图
    { type: 'view', name: _i18n.t('utils.view'), properties: { x: 0, y: 0, w: 33.33, h: 415 } },
    // 视图
    { type: 'chart', name: _i18n.t('utils.chart'), properties: { x: 0, y: 0, w: 50, h: 310 } }
  ],
  system: [
    // 任务泳道图
    {
      type: 'taskYdt',
      name: _i18n.t('utils.taskYongdaotu'),
      viewStyle: '0',
      properties: { x: 0, y: 0, w: 100, h: 180 }
    },
    // 日程
    {
      type: 'schedule',
      name: _i18n.t('base_common.schedule'),
      properties: { x: 0, y: 0, w: 100, h: 520 }
    },
    // 协作
    {
      type: 'project',
      name: _i18n.t('base_common.project'),
      properties: { x: 0, y: 0, w: 50, h: 415 }
    },
    // 知识库
    {
      type: 'repositoryLibraries',
      name: _i18n.t('base_common.knowledge'),
      properties: { x: 0, y: 0, w: 33.33, h: 310 }
    },
    // 备忘录
    {
      type: 'memo',
      name: _i18n.t('base_common.memo'),
      properties: { x: 0, y: 0, w: 33.33, h: 310 },
      pageInfo: { pageNum: 1, pageSize: 5 }
    },
    // 审批
    {
      type: 'approval',
      name: _i18n.t('base_common.approval'),
      properties: { x: 0, y: 0, w: 50, h: 415 },
      pageInfo: { pageNum: 1, pageSize: 5 }
    },
    // 文件库
    {
      type: 'fileLibrary',
      name: _i18n.t('base_common.library'),
      properties: { x: 0, y: 0, w: 33.33, h: 310 }
    }
  ],
  // 任务
  task: {
    type: 'task',
    name: _i18n.t('base_common.task'),
    properties: { x: 0, y: 0, w: 50, h: 415 },
    pageInfo: { pageNum: 1, pageSize: 5 }
  }
}
// }

// 单行文本和数字操作符
const OperatorList = function () {
  return {
    text: [
      { input: 'TEXT', label: _i18n.t('globalSettings.baohan'), type: 'CONTAIN' }, // 包含
      { input: 'TEXT', label: _i18n.t('globalSettings.bubaohan'), type: 'NCONTAIN' }, // 不包含
      { input: 'TEXT', label: _i18n.t('globalSettings.dengyu'), type: 'EQUALS' }, // 等于
      { input: 'TEXT', label: _i18n.t('globalSettings.budengyu'), type: 'NEQUALS' }, // 不等于
      { input: 'TEXT', label: _i18n.t('data_analysis.weikong'), type: 'ISNULL' }, // 为空
      { input: 'TEXT', label: _i18n.t('data_analysis.buweikong'), type: 'ISNOTNULL' }, // 不为空
      { input: 'TEXT', label: _i18n.t('custom.startString'), type: 'PREFIX' } // 起始字符
    ],
    number: [
      { input: 'NUMBER', label: _i18n.t('globalSettings.dayu'), type: 'GREATER' }, // 大于
      { input: 'NUMBER', label: _i18n.t('globalSettings.xiaoyu'), type: 'LESS' }, // 小于
      { input: 'NUMBER', label: _i18n.t('globalSettings.dengyu'), type: 'NMEQUALS' }, // 等于
      { input: 'NUMBER', label: _i18n.t('globalSettings.budengyu'), type: 'NMNEQUALS' }, // 不等于
      { input: 'NUMBER', label: _i18n.t('globalSettings.dayudengyu'), type: 'GREATERE' }, // 大于等于
      { input: 'NUMBER', label: _i18n.t('globalSettings.xiaoyudengyu'), type: 'LESSE' }, // 小于等于
      { input: 'NUMBER', label: _i18n.t('data_analysis.weikong'), type: 'ISNULL' }, // 为空
      { input: 'NUMBER', label: _i18n.t('data_analysis.buweikong'), type: 'ISNOTNULL' } // 不为空
    ],
    personnel: [
      { input: 'PERSONNEL', label: _i18n.t('globalSettings.baohan'), type: 'CONTAIN' }, // 包含
      { input: 'PERSONNEL', label: _i18n.t('globalSettings.beibaohan'), type: 'BCONTAIN' }, // 被包含
      { input: 'SELECT', label: _i18n.t('globalSettings.bubeibaohan'), type: 'NBCONTAIN' }, // 不被包含
      { input: 'PERSONNEL', label: _i18n.t('email.notIncluded'), type: 'NCONTAIN' }, // 不包含
      { input: 'PERSONNEL', label: _i18n.t('globalSettings.dengyu'), type: 'EQUALS' }, // 等于
      { input: 'PERSONNEL', label: _i18n.t('globalSettings.budengyu'), type: 'NEQUALS' }, // 不等于
      { input: 'PERSONNEL', label: _i18n.t('data_analysis.weikong'), type: 'ISNULL' }, // 为空
      { input: 'PERSONNEL', label: _i18n.t('data_analysis.buweikong'), type: 'ISNOTNULL' } // 不为空
    ],
    datetime: [
      { input: 'DATE', label: '位于', type: 'BETWEEN' }, // 位于
      { input: 'DATE', label: _i18n.t('custom_backstage.before'), type: 'BEFORE' }, // 以前
      { input: 'DATE', label: _i18n.t('custom_backstage.after'), type: 'AFTER' }, // 以后
      { label: _i18n.t('base_common.screenInfo.lastQuarter'), type: 'LQUARTER' }, // 上季度
      { label: _i18n.t('base_common.screenInfo.lastMonth'), type: 'LMONTH' }, // 上月
      { label: _i18n.t('base_common.screenInfo.lastWeek'), type: 'LWEEK' }, // 上周
      { label: _i18n.t('custom.yesterday'), type: 'YESTERDAY' }, // 昨日
      { label: _i18n.t('data_analysis.today'), type: 'TODAY' }, // 今日
      { label: '大于今天', type: 'ATODAY' }, // 大于今天
      { label: '小于今天', type: 'BTODAY' }, // 小于今天
      { label: _i18n.t('base_common.screenInfo.thisWeek'), type: 'WEEK' }, // 本周
      { label: _i18n.t('base_common.screenInfo.thisMonth'), type: 'MONTH' }, // 本月
      { label: _i18n.t('base_common.screenInfo.thisQuarter'), type: 'QUARTER' }, // 本季度
      { label: _i18n.t('base_common.screenInfo.thisYear'), type: 'YEAR' }, // 本年
      { label: _i18n.t('data_analysis.weikong'), type: 'ISNULL' }, // 为空
      { label: _i18n.t('data_analysis.buweikong'), type: 'ISNOTNULL' } // 不为空
    ]
  }
}

/**
 * 国际手机号
 * 删除重复262、61
 */
const country = [
  { value: '355', id: '355', label: '阿尔巴尼亚' },
  { value: '213', id: '213', label: '阿尔及利亚' },
  { value: '93', id: '93', label: '阿富汗' },
  { value: '54', id: '54', label: '阿根廷' },
  { value: '297', id: '297', label: '阿鲁巴岛' },
  { value: '968', id: '968', label: '阿曼' },
  { value: '994', id: '994', label: '阿塞拜疆' },
  { value: '247', id: '247', label: '阿森松(英)' },
  { value: '20', id: '20', label: '埃及' },
  { value: '251', id: '251', label: '埃塞俄比亚' },
  { value: '353', id: '353', label: '爱尔兰' },
  { value: '372', id: '372', label: '爱沙尼亚' },
  { value: '376', id: '376', label: '安道尔' },
  { value: '244', id: '244', label: '安哥拉' },
  { value: '1264', id: '1264', label: '安圭拉岛(英)' },
  { value: '1268', id: '1268', label: '安提瓜和巴布达' },
  { value: '43', id: '43', label: '奥地利' },
  { value: '61', id: '61', label: '澳大利亚' },
  { value: '853', id: '853', label: '澳门' },
  { value: '1246', id: '1246', label: '巴巴多斯' },
  { value: '675', id: '675', label: '巴布亚新几内亚' },
  { value: '1242', id: '1242', label: '巴哈马国' },
  { value: '92', id: '92', label: '巴基斯坦' },
  { value: '595', id: '595', label: '巴拉圭' },
  { value: '973', id: '973', label: '巴林' },
  { value: '507', id: '507', label: '巴拿马' },
  { value: '55', id: '55', label: '巴西' },
  { value: '375', id: '375', label: '白俄罗斯' },
  { value: '1441', id: '1441', label: '百慕大群岛(英)' },
  { value: '359', id: '359', label: '保加利亚' },
  { value: '229', id: '229', label: '贝宁' },
  { value: '32', id: '32', label: '比利时' },
  { value: '354', id: '354', label: '冰岛' },
  { value: '1', id: '1-3', label: '波多黎各(美)' },
  { value: '48', id: '48', label: '波兰' },
  { value: '387', id: '387', label: '波斯尼亚和黑塞哥维那' },
  { value: '591', id: '591', label: '玻利维亚' },
  { value: '501', id: '501', label: '伯利兹' },
  { value: '267', id: '267', label: '博茨瓦纳' },
  { value: '975', id: '975', label: '不丹' },
  { value: '226', id: '226', label: '布基纳法索' },
  { value: '257', id: '257', label: '布隆迪' },
  { value: '850', id: '850', label: '朝鲜' },
  { value: '240', id: '240', label: '赤道几内亚' },
  { value: '45', id: '45', label: '丹麦' },
  { value: '49', id: '49', label: '德国' },
  { value: '1684', id: '1684', label: '东萨摩亚(美)' },
  { value: '228', id: '228', label: '多哥' },
  { value: '1809', id: '1809', label: '多米尼加共和国' },
  { value: '1767', id: '1767', label: '多米尼克国' },
  { value: '7', id: '7-1', label: '俄罗斯' },
  { value: '593', id: '593', label: '厄瓜多尔' },
  { value: '291', id: '291', label: '厄立特里亚' },
  { value: '33', id: '33', label: '法国' },
  { value: '298', id: '298', label: '法罗群岛(丹)' },
  { value: '689', id: '689', label: '法属波里尼西亚' },
  { value: '14397', id: '14397', label: '梵蒂冈' },
  { value: '63', id: '63', label: '菲律宾' },
  { value: '679', id: '679', label: '斐济' },
  { value: '358', id: '358', label: '芬兰' },
  { value: '238', id: '238', label: '佛得角' },
  { value: '500', id: '500', label: '福克兰群岛' },
  { value: '220', id: '220', label: '冈比亚' },
  { value: '242', id: '242', label: '刚果' },
  { value: '57', id: '57', label: '哥伦比亚' },
  { value: '506', id: '506', label: '哥斯达黎加' },
  { value: '1473', id: '1473', label: '格林纳达' },
  { value: '299', id: '299', label: '格陵兰岛' },
  { value: '995', id: '995', label: '格鲁吉亚' },
  { value: '53', id: '53', label: '古巴' },
  { value: '590', id: '590', label: '瓜德罗普岛(法)' },
  { value: '1671', id: '1671', label: '关岛(美)' },
  { value: '592', id: '592', label: '圭亚那' },
  { value: '7', id: '7-2', label: '哈萨克斯坦' },
  { value: '509', id: '509', label: '海地' },
  { value: '82', id: '82', label: '韩国' },
  { value: '31', id: '31', label: '荷兰' },
  { value: '599', id: '599', label: '荷属安的列斯群岛' },
  { value: '504', id: '504', label: '洪都拉斯' },
  { value: '686', id: '686', label: '基里巴斯' },
  { value: '253', id: '253', label: '吉布提' },
  { value: '996', id: '996', label: '吉尔吉斯斯坦' },
  { value: '224', id: '224', label: '几内亚' },
  { value: '245', id: '245', label: '几内亚比绍' },
  { value: '1', id: '1-2', label: '加拿大' },
  { value: '233', id: '233', label: '加纳' },
  { value: '241', id: '241', label: '加蓬' },
  { value: '855', id: '855', label: '柬埔塞' },
  { value: '420', id: '420', label: '捷克' },
  { value: '263', id: '263', label: '津巴布韦' },
  { value: '237', id: '237', label: '喀麦隆' },
  { value: '974', id: '974', label: '卡塔尔' },
  { value: '1345', id: '1345', label: '开曼群岛(英)' },
  { value: '682', id: '682', label: '科克群岛(新)' },
  { value: '269', id: '269', label: '科摩罗' },
  { value: '225', id: '225', label: '科特迪瓦' },
  { value: '965', id: '965', label: '科威特' },
  { value: '385', id: '385', label: '克罗地亚' },
  { value: '254', id: '254', label: '肯尼亚' },
  { value: '371', id: '371', label: '拉脱维亚' },
  { value: '266', id: '266', label: '莱索托' },
  { value: '856', id: '856', label: '老挝' },
  { value: '961', id: '961', label: '黎巴嫩' },
  { value: '370', id: '370', label: '立陶宛' },
  { value: '231', id: '231', label: '利比里亚' },
  { value: '218', id: '218', label: '利比亚' },
  { value: '423', id: '423', label: '列支敦士登' },
  { value: '352', id: '352', label: '卢森堡' },
  { value: '250', id: '250', label: '卢旺达' },
  { value: '40', id: '40', label: '罗马尼亚' },
  { value: '261', id: '261', label: '马达加斯加' },
  { value: '960', id: '960', label: '马尔代夫' },
  { value: '356', id: '356', label: '马耳他' },
  { value: '265', id: '265', label: '马拉维' },
  { value: '60', id: '60', label: '马来西亚' },
  { value: '223', id: '223', label: '马里' },
  { value: '1670', id: '1670', label: '马里亚纳群岛' },
  { value: '389', id: '389', label: '马其顿' },
  { value: '692', id: '692', label: '马绍尔群岛' },
  { value: '596', id: '596', label: '马提尼克(法)' },
  { value: '230', id: '230', label: '毛里求斯' },
  { value: '222', id: '222', label: '毛里塔尼亚' },
  { value: '1', id: '1-1', label: '美国' },
  { value: '976', id: '976', label: '蒙古' },
  { value: '1664', id: '1664', label: '蒙特塞拉特岛(英)' },
  { value: '880', id: '880', label: '孟加拉国' },
  { value: '51', id: '51', label: '秘鲁' },
  { value: '691', id: '691', label: '密克罗尼西亚(美)' },
  { value: '95', id: '95', label: '缅甸' },
  { value: '373', id: '373', label: '摩尔多瓦' },
  { value: '212', id: '212', label: '摩洛哥' },
  { value: '377', id: '377', label: '摩纳哥' },
  { value: '258', id: '258', label: '莫桑比克' },
  { value: '52', id: '52', label: '墨西哥' },
  { value: '264', id: '264', label: '纳米比亚' },
  { value: '27', id: '27', label: '南非' },
  { value: '381', id: '381', label: '南斯拉夫' },
  { value: '674', id: '674', label: '瑙鲁' },
  { value: '977', id: '977', label: '尼泊尔' },
  { value: '505', id: '505', label: '尼加拉瓜' },
  { value: '227', id: '227', label: '尼日尔' },
  { value: '234', id: '234', label: '尼日利亚' },
  { value: '683', id: '683', label: '纽埃岛(新)' },
  { value: '47', id: '47', label: '挪威' },
  { value: '672', id: '672', label: '诺福克岛(澳)' },
  { value: '680', id: '680', label: '帕劳(美)' },
  { value: '351', id: '351', label: '葡萄牙' },
  { value: '81', id: '81', label: '日本' },
  { value: '46', id: '46', label: '瑞典' },
  { value: '41', id: '41', label: '瑞士' },
  { value: '503', id: '503', label: '萨尔瓦多' },
  { value: '232', id: '232', label: '塞拉利昂' },
  { value: '221', id: '221', label: '塞内加尔' },
  { value: '357', id: '357', label: '塞浦路斯' },
  { value: '248', id: '248', label: '塞舌尔' },
  { value: '259', id: '259', label: '桑给巴尔' },
  { value: '966', id: '966', label: '沙特阿拉伯' },
  { value: '239', id: '239', label: '圣多美和普林西比' },
  { value: '290', id: '290', label: '圣赫勒拿' },
  { value: '1869', id: '1869', label: '圣克里斯托弗和尼维斯' },
  { value: '1758', id: '1758', label: '圣卢西亚' },
  { value: '378', id: '378', label: '圣马力诺' },
  { value: '508', id: '508', label: '圣皮埃尔岛及密克隆岛' },
  { value: '1784', id: '1784', label: '圣文森特岛(英)' },
  { value: '94', id: '94', label: '斯里兰卡' },
  { value: '421', id: '421', label: '斯洛伐克' },
  { value: '386', id: '386', label: '斯洛文尼亚' },
  { value: '268', id: '268', label: '斯威士兰' },
  { value: '249', id: '249', label: '苏丹' },
  { value: '597', id: '597', label: '苏里南' },
  { value: '677', id: '677', label: '所罗门群岛' },
  { value: '252', id: '252', label: '索马里' },
  { value: '992', id: '992', label: '塔吉克斯坦' },
  { value: '886', id: '886', label: '台湾' },
  { value: '66', id: '66', label: '泰国' },
  { value: '255', id: '255', label: '坦桑尼亚' },
  { value: '676', id: '676', label: '汤加' },
  { value: '1649', id: '1649', label: '特克斯和凯科斯群岛(英)' },
  { value: '1868', id: '1868', label: '特立尼达和多巴哥' },
  { value: '216', id: '216', label: '突尼斯' },
  { value: '688', id: '688', label: '图瓦卢' },
  { value: '90', id: '90', label: '土耳其' },
  { value: '993', id: '993', label: '土库曼斯坦' },
  { value: '678', id: '678', label: '瓦努阿图' },
  { value: '502', id: '502', label: '危地马拉' },
  { value: '1340', id: '1340', label: '维尔京群岛(英)' },
  { value: '58', id: '58', label: '委内瑞拉' },
  { value: '256', id: '256', label: '乌干达' },
  { value: '380', id: '380', label: '乌克兰' },
  { value: '598', id: '598', label: '乌拉圭' },
  { value: '998', id: '998', label: '乌兹别克斯坦' },
  { value: '34', id: '34', label: '西班牙' },
  { value: '685', id: '685', label: '西萨摩亚' },
  { value: '30', id: '30', label: '希腊' },
  { value: '852', id: '852', label: '香港' },
  { value: '65', id: '65', label: '新加坡' },
  { value: '687', id: '687', label: '新喀里多尼亚群岛(法)' },
  { value: '64', id: '64', label: '新西兰' },
  { value: '36', id: '36', label: '匈牙利' },
  { value: '963', id: '963', label: '叙利亚' },
  { value: '1876', id: '1876', label: '牙买加' },
  { value: '374', id: '374', label: '亚美尼亚' },
  { value: '967', id: '967', label: '也门' },
  { value: '964', id: '964', label: '伊拉克' },
  { value: '98', id: '98', label: '伊郎' },
  { value: '972', id: '972', label: '以色列' },
  { value: '39', id: '39', label: '意大利' },
  { value: '91', id: '91', label: '印度' },
  { value: '62', id: '62', label: '印度尼西亚' },
  { value: '44', id: '44', label: '英国' },
  { value: '962', id: '962', label: '约旦' },
  { value: '84', id: '84', label: '越南' },
  { value: '260', id: '260', label: '赞比亚' },
  { value: '235', id: '235', label: '乍得' },
  { value: '350', id: '350', label: '直布罗陀(英)' },
  { value: '56', id: '56', label: '智利' },
  { value: '236', id: '236', label: '中非' },
  { value: '86', id: '86', label: '中国大陆', reg: regular.phone }
]

/**
 * 国际语言
 */
const language = [
  {
    value: 'zh',
    label: '中文'
  },
  {
    value: 'zh_TW',
    label: '繁體中文'
  },
  {
    value: 'en',
    label: 'English'
  }
  // {
  //   value: 'ja',
  //   label: '日本語'
  // },
  // {
  //   value: 'ko',
  //   label: '한국어'
  // },
  // {
  //   value: 'fr',
  //   label: 'Français'
  // }
]

// 切换语言国际化实例返回方法
const testFun = function () {
  return {
    a: _i18n.t('base_common.knowledgeDoc'),
    b: _i18n.t('base_common.approval')
  }
}

// web表单链接
const webUrl = {
  a:
    process.env.VUE_APP_ADDRESS_WEB_FORM +
    '/#/fZFun8QuU.fZFun8QuU.73.28.bean1584683732610.1.teamface_id', // 技术支持
  b:
    process.env.VUE_APP_ADDRESS_WEB_FORM +
    '/#/PB2FXgZbK.PB2FXgZbK.73.28.bean1529575710113.1.teamface_id', // 需求反馈
  c:
    process.env.VUE_APP_ADDRESS_WEB_FORM +
    '/#/QZq4nugZE.QZq4nugZE.73.28.bean1584256974185.1.teamface_id', // 产品评价
  d:
    process.env.VUE_APP_ADDRESS_WEB_FORM +
    '/#/HYDryaxwd.HYDryaxwd.73.28.bean1584256792935.1.teamface_id',
  e:
    process.env.VUE_APP_ADDRESS_WEB_FORM +
    '/#/Ojcnp1uxX.Ojcnp1uxX.73.28.bean1584677802644.1.teamface_id',
  f:
    process.env.VUE_APP_ADDRESS_WEB_FORM +
    '/#/ed8EgGHkJ.ed8EgGHkJ.73.28.bean1584677723453.1.teamface_id',
  h:
    process.env.VUE_APP_ADDRESS_WEB_FORM +
    '/#/LuwabA4Sb.LuwabA4Sb.73.28.bean1584933253165.2.teamface_id' // 定制需求
}

const interviewTemplate = [
  {
    name: 'OKR 制定沟通',
    sub: [
      {
        title: '过程',
        sub: [
          { content: '上一阶段的OKR完成的怎么样？', id: 1 },
          { content: '有哪些成功的经验或者是失败的教训？', id: 2 },
          { content: '是否做出一些以前没有使用过的新方法？', id: 3 },
          { content: '你遇到了哪些难以解决的障碍？', id: 4 },
          { content: '你是如何进行调整的？', id: 5 },
          { content: '如果能重来，你会重点关注哪个环节？', id: 6 }
        ]
      },
      {
        title: '展望',
        sub: [
          { content: '下一阶段你的目标是什么？', id: 7 },
          { content: '具体的关键结果是什么？', id: 8 },
          { content: '你确定这就是你未来的OKR吗？', id: 9 },
          { content: '你可能会遇到什么样的风险？', id: 10 },
          { content: '你需要得到什么样的资源？', id: 11 },
          { content: '为了达成，你是否有一些新的方法可以尝试？', id: 12 },
          { content: '除此之外，还有哪些方法？', id: 13 }
        ]
      }
    ],
    id: 1
  },
  {
    name: 'OKR 进展反馈',
    sub: [
      {
        title: 'aaa',
        sub: [
          { content: '过去一周你的 OKR 整体进展怎么样', id: 14 },
          { content: '具体做了哪些项目和任务？', id: 15 },
          { content: '这些工作完成的结果怎么样？', id: 16 },
          { content: '哪些工作做的比较出色？', id: 17 },
          { content: '哪些工作遇到了比较大的障碍？', id: 18 },
          { content: '当你发现问题后是如何进行调整的？', id: 19 }
        ]
      },
      {
        title: '展望',
        sub: [
          { content: '下一周你准备做什么？', id: 20 },
          { content: '为什么要做这些工作？', id: 21 },
          { content: '做的过程中可能遇到什么风险？', id: 22 },
          { content: '你需要什么资源或者是他人支持？', id: 23 },
          { content: '除此之外，还有其他的好计划吗？', id: 24 }
        ]
      }
    ],
    id: 2
  },
  {
    name: 'OKR 对齐',
    sub: [
      {
        title: '原因',
        sub: [
          { content: '你是根据上级的哪个OKR制定的自己的 OKR？', id: 25 },
          { content: '这个 OKR 能够聚焦你当下最重要的工作吗？', id: 26 },
          { content: '为什么你会认为它是最重要的？', id: 27 },
          { content: '你的 OKR 能够为上级 OKR达 成提供多少支持？', id: 28 },
          { content: '你认为这是你最大的价值吗？', id: 29 },
          { content: '除了这些 OKR 之外，你是否还有其他的价值？', id: 30 }
        ]
      },
      {
        title: '关联',
        sub: [
          { content: '你的 OKR 都和谁有关？', id: 31 },
          { content: '他们知道你的这个 OKR 吗？', id: 32 },
          { content: '需要协同的工作，对方给你承诺了吗？', id: 33 },
          { content: '你怎么确保对方一定是能够及时的给与你支持的？', id: 34 }
        ]
      }
    ],
    id: 3
  },
  {
    name: 'OKR 复盘',
    sub: [
      {
        title: '回望',
        sub: [
          { content: '你当初为什么定这个 OKR？', id: 35 },
          { content: '这个 OKR 的达成实现的你的期望值吗？', id: 36 },
          { content: '如果时间能重来，你是否会修改这个 OKR？', id: 37 },
          { content: '完成 OKR 的过程中，所制定的行动计划合理吗？', id: 38 }
        ]
      },
      {
        title: '总结',
        sub: [
          { content: '这个 OKR 具体的完成情况怎么样？', id: 39 },
          { content: '在落地过程中印象最深刻的事情是什么？', id: 40 },
          { content: '你有哪些成功的经验或失败的教训？', id: 41 },
          { content: '你是否获得了足够的支持？', id: 42 },
          { content: '你做了哪些创新的工作？', id: 43 }
        ]
      },
      {
        title: '展望',
        sub: [
          { content: '下一阶段你有什么规划？', id: 44 },
          { content: '你准备在工作中做哪些调整？', id: 45 },
          { content: '你需要在哪些方面提升自己的能力？', id: 46 }
        ]
      }
    ],
    id: 4
  },
  {
    name: '安排任务',
    sub: [
      {
        title: '交代任务',
        sub: [
          { content: '你清楚这个工作是要做什么吗？', id: 47 },
          { content: '你准备怎么完成这个工作？', id: 48 },
          { content: '你当下认为完成这个工作有什么障碍吗？', id: 49 },
          { content: '你准备如何解决这些障碍？', id: 50 },
          { content: '你希望我给你什么支持？', id: 51 }
        ]
      },
      {
        title: '追踪任务',
        sub: [
          { content: '这个工作完成的怎么样了？', id: 52 },
          { content: '是否需要做出一些调整？', id: 53 },
          { content: '我还能为你做些什么，才能让你把这个工作完成？', id: 54 }
        ]
      }
    ],
    id: 5
  },
  {
    name: '隔级一对一面谈',
    sub: [
      {
        title: '谈话要点',
        sub: [
          { content: '你在工作中快乐吗？是什么让你这么觉得？', id: 55 },
          { content: '你最近取得的最好成绩是什么？你对此感到感激吗？', id: 56 },
          { content: '您如何看待公司的整体未来和愿景？是什么让你这么觉得？', id: 57 },
          { content: '如果我们作为一个团队可以在任何方面有所改进，我们应该怎样做呢？', id: 58 },
          { content: '你在公司里敬佩谁，为什么？', id: 59 },
          { content: '你的经理或我可以做些什么来更好地支持你的工作？', id: 60 },
          { content: '你想了解公司的哪个领域/信息？', id: 61 },
          { content: '有什么阻碍/困扰你吗？', id: 62 }
        ]
      }
    ],
    id: 6
  },
  {
    name: '新员工第一次面谈',
    sub: [
      {
        title: '热身',
        sub: [
          { content: '说说你自己，是什么激励了你，你崇拜谁？', id: 63 },
          { content: '你去过的最喜欢的地方是哪里？', id: 64 },
          { content: '你当前的工作你最喜欢什么？', id: 65 }
        ]
      },
      {
        title: '团队合作',
        sub: [
          {
            content: '让我们谈谈我们的 1 对 1 面谈，我们为什么这样做，以及多长时间做一次。',
            id: 66
          },
          { content: '让我们谈谈我们的团队以及我们如何一起工作。', id: 67 },
          { content: '以下是你应该了解的关于我的个性以及我喜欢的工作方式。', id: 68 },
          { content: '作为你的经理，你对我有什么期望？', id: 69 }
        ]
      },
      {
        title: '职业和计划',
        sub: [
          { content: '让我们谈谈我对您作为专业人士的期望。', id: 70 },
          { content: '您如何看待 1 到 3 年后的职业生涯？你希望有什么成就？', id: 71 },
          { content: '为了实现这个目标，你需要我提供什么帮助？', id: 72 },
          { content: '有什么你认为重要的事情要和我分享吗？', id: 73 }
        ]
      }
    ],
    id: 7
  },
  {
    name: '远程一对一会议',
    sub: [
      {
        title: '热身',
        sub: [
          { content: '事情进行得如何？自从我们上次见面以来发生了哪些有趣的事情？', id: 74 },
          { content: '你最关心的是什么？你想从什么开始我们沟通？', id: 75 }
        ]
      },
      {
        title: '合作',
        sub: [
          { content: '这周你在做什么？你的目标进展如何？', id: 76 },
          { content: '你接下来几周的计划是什么？', id: 77 },
          { content: '您如何评价我们作为一个团队的沟通？你认为我们应该改进什么？', id: 78 },
          { content: '我们公司还能做些什么来更好地支持我们的远程团队成员？', id: 79 },
          { content: '您是否感到与我们的团队成员有联系和支持？', id: 80 }
        ]
      }
    ],
    id: 8
  },
  {
    name: '每周快速对齐',
    sub: [
      {
        title: '过程',
        sub: [
          { content: '自上次对齐之后各方面进展顺利吗？', id: 81 },
          { content: '遇到了哪些障碍？', id: 82 }
        ]
      },
      {
        title: '执行',
        sub: [
          { content: '之后的工作目标是什么？', id: 83 },
          { content: '针对当前的目标，你正在做什么或者打算开始做些什么实现这些目标？', id: 84 },
          { content: '我们有什么没有涉及到你想讨论的呢？', id: 85 }
        ]
      }
    ],
    id: 9
  },
  {
    name: '每月总结面谈',
    sub: [
      {
        title: '过程',
        sub: [
          { content: '这个月过得怎么样？', id: 86 },
          { content: '自上次面谈以来目标进展顺利吗？', id: 87 },
          { content: '遇到了哪些挑战与障碍？', id: 88 }
        ]
      },
      {
        title: '展望',
        sub: [
          { content: '接下来一个月工作的重点是什么？', id: 89 },
          { content: '你最感兴趣哪个点？', id: 90 },
          { content: '对于这些，你会给自己定义较好完成的标准是什么？', id: 91 },
          { content: '你正在采取或想要通过哪些行为实现这些目标？', id: 92 },
          { content: '我们有什么没有涉及你想讨论的呢？', id: 93 }
        ]
      }
    ],
    id: 10
  }
]

const describe = {
  'roster/saveEmployeeRemind': {
    '-2': '已存在相同类型的提醒记录了'
  },
  'archivesAppService/saveEducExperience': {
    '-2': '存在学校和入校时间均相同的数据'
  },
  'archivesAppService/addWorkExperience': {
    '-2': '存在公司和入职时间均相同的数据'
  },
  'roster/saveEmidSetting': {
    '-2': '已存在相同的适用部门和适用员工类型规则'
  },
  'archivesAppService/addCertificate': {
    '-2': '证照编号存在重复'
  },
  'blackListService/operateBlackList': {
    '-2': '证件号存在重复'
  },
  'contractManagementService/saveContract': {
    '-2': '合同编号存在重复'
  },
  'contractManagementService/saveAgreement': {
    '-2': '协议编号存在重复'
  },
  'roster/saveLeaver': {
    '-2': '该员工已经存在【待离职】列表中'
  },
  'department/saveWorkAddress': {
    '-2': '该地址存在重复',
    '-3': '该地址被引用，不能删除'
  },
  'attendanceHoliday/saveLeaveType': {
    '-2': '假期类型存在重复',
    '-3': '该类型已被假期方案引用'
  },
  'employee/saveBeanData': {
    entry: '当前人员存在审批中的数据（入职），请审批结束后在发起',
    formal: '当前人员存在审批中的数据（转正），请审批结束后在发起',
    leave: '当前人员存在审批中的数据（离职），请审批结束后在发起',
    handover: '当前人员存在审批中的数据（离职交接），请审批结束后在发起',
    transfer: '当前人员存在审批中的数据（调动），请审批结束后在发起',
    contract: '当前人员存在审批中的合同，请审批结束后在发起',
    '-3': '合同在该时间段有重复',
    '-2': '合同编号存在重复'
  }
}

export {
  component1,
  component2,
  subformList,
  symbolList,
  formulaType,
  formulaType2,
  colors24,
  defaultAppIcon,
  defaultModuleIcon,
  themes,
  wthemes,
  regular,
  taskDefaultFields,
  defaultModule,
  TFParameter,
  webformComponents,
  appIndustry,
  barcodeStyleList,
  formulaReturn1,
  formulaReturn2,
  commonField,
  areaInit,
  assembly,
  colorsPicklist24,
  systemModule,
  workbench,
  OperatorList,
  country,
  language,
  webUrl,
  testFun,
  interviewTemplate,
  describe
}
